!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t(require("@apollo/react-hooks")):"function"==typeof define&&define.amd?define(["@apollo/react-hooks"],t):"object"==typeof exports?exports.index=t(require("@apollo/react-hooks")):e.index=t(e["@apollo/react-hooks"])}(window,(function(e){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="https://cdn.websky.aero/SZ/static/",r(r.s=1)}([function(t,r){t.exports=e},function(e,t,r){"use strict";r.r(t),r.d(t,"ActualizationStatus",(function(){return le})),r.d(t,"AeroexpressClass",(function(){return fe})),r.d(t,"AeroexpressDirection",(function(){return me})),r.d(t,"AircraftInfoParameterType",(function(){return pe})),r.d(t,"AmenityType",(function(){return he})),r.d(t,"AviaCouponStatus",(function(){return ge})),r.d(t,"AviaCouponType",(function(){return ye})),r.d(t,"AviaPassengerType",(function(){return ve})),r.d(t,"BaggageType",(function(){return Se})),r.d(t,"BookingStatusEnum",(function(){return Pe})),r.d(t,"CheckinAccessType",(function(){return De})),r.d(t,"CheckinDocumentType",(function(){return Ce})),r.d(t,"CheckinOrderStatus",(function(){return Fe})),r.d(t,"DeviceType",(function(){return Ie})),r.d(t,"DocTypes",(function(){return Te})),r.d(t,"ExarePriceDetailsPriceElementType",(function(){return Oe})),r.d(t,"ExareReason",(function(){return Ae})),r.d(t,"ExareReasonDocs",(function(){return $e})),r.d(t,"ExareSeatReleaseMode",(function(){return Ee})),r.d(t,"ExareStatus",(function(){return Me})),r.d(t,"FareFamilyOptionsType",(function(){return Ne})),r.d(t,"FareFeaturePaymentType",(function(){return Re})),r.d(t,"FfpAccountFieldEnum",(function(){return be})),r.d(t,"FileExtensions",(function(){return xe})),r.d(t,"FlightClass",(function(){return ke})),r.d(t,"FlightSegmentStatus",(function(){return Le})),r.d(t,"FlightStatusInfoStatus",(function(){return we})),r.d(t,"GdsServiceProductStatus",(function(){return Ge})),r.d(t,"GdsServiceRestrictionType",(function(){return Qe})),r.d(t,"GdsServiceVipSubType",(function(){return _e})),r.d(t,"Gender",(function(){return Be})),r.d(t,"InfoMessagePositionsEnum",(function(){return ze})),r.d(t,"InfoMessageTypeEnum",(function(){return Ue})),r.d(t,"InquiryType",(function(){return Ve})),r.d(t,"InsuranceType",(function(){return qe})),r.d(t,"LocationAdditionalGroupType",(function(){return We})),r.d(t,"LocationGroupType",(function(){return je})),r.d(t,"LocationMatchType",(function(){return Ke})),r.d(t,"LoginType",(function(){return He})),r.d(t,"NASProductCategory",(function(){return Ye})),r.d(t,"NASProductDirection",(function(){return Je})),r.d(t,"NASProductType",(function(){return Xe})),r.d(t,"NASStatus",(function(){return Ze})),r.d(t,"OauthServiceType",(function(){return et})),r.d(t,"OrderAdditionalServiceGdsServiceServiceType",(function(){return tt})),r.d(t,"OrderAdditionalServiceType",(function(){return rt})),r.d(t,"OrderDocumentType",(function(){return nt})),r.d(t,"OrderFlownStatus",(function(){return it})),r.d(t,"OrderStatus",(function(){return at})),r.d(t,"PassTypeAgeCategoryType",(function(){return ot})),r.d(t,"PaximizerCommunicationSectionEnum",(function(){return ut})),r.d(t,"PaymentProvider",(function(){return st})),r.d(t,"PaymentStatusEnum",(function(){return ct})),r.d(t,"PaymentTransactionProductType",(function(){return dt})),r.d(t,"ProfileFieldEnum",(function(){return lt})),r.d(t,"RouteType",(function(){return ft})),r.d(t,"SeatComfort",(function(){return mt})),r.d(t,"SeatMapPermissions",(function(){return pt})),r.d(t,"SeatMapRestrictions",(function(){return ht})),r.d(t,"SeatType",(function(){return gt})),r.d(t,"SettingValueTypeEnum",(function(){return yt})),r.d(t,"SortAttribute",(function(){return vt})),r.d(t,"SortOrder",(function(){return St})),r.d(t,"SsrStatus",(function(){return Pt})),r.d(t,"SubsidyType",(function(){return Dt})),r.d(t,"SunSides",(function(){return Ct})),r.d(t,"TemperatureUnits",(function(){return Ft})),r.d(t,"TimelineStep",(function(){return It})),r.d(t,"TravellerFieldEnum",(function(){return Tt})),r.d(t,"TravellerProfileMatchStatus",(function(){return Ot})),r.d(t,"TravellerVisaFieldEnum",(function(){return At})),r.d(t,"UserLoyaltyCardLevels",(function(){return $t})),r.d(t,"WSubscriptionsClientField",(function(){return Et})),r.d(t,"WSubscriptionsFullNameType",(function(){return Mt})),r.d(t,"WSubscriptionsSellCase",(function(){return Nt})),r.d(t,"WSubscriptionsServiceType",(function(){return Rt})),r.d(t,"WSubscriptionsStatus",(function(){return bt})),r.d(t,"WeatherTypes",(function(){return xt})),r.d(t,"Weekdays",(function(){return kt})),r.d(t,"WidgetType",(function(){return Lt})),r.d(t,"AccountSegmentFragmentDoc",(function(){return Qt})),r.d(t,"MoneyFragmentDoc",(function(){return _t})),r.d(t,"AccountOrdersListFragmentDoc",(function(){return Bt})),r.d(t,"CardHolderFragmentDoc",(function(){return zt})),r.d(t,"UserFfpInfoFragmentDoc",(function(){return Ut})),r.d(t,"AuthMethodFragmentDoc",(function(){return Vt})),r.d(t,"NameValueMapFragmentDoc",(function(){return qt})),r.d(t,"UserProfileInfoFragmentDoc",(function(){return Wt})),r.d(t,"UserProfileFfpInfoFragmentDoc",(function(){return jt})),r.d(t,"OptionParameterFragmentDoc",(function(){return Kt})),r.d(t,"IValidationRuleFragmentDoc",(function(){return Ht})),r.d(t,"WithParameterFragmentDoc",(function(){return Yt})),r.d(t,"ChangeValidationRuleFragmentDoc",(function(){return Jt})),r.d(t,"ChangeTravellerParameterFragmentDoc",(function(){return Xt})),r.d(t,"ChangeTravellerDataTravellerInfoFragmentDoc",(function(){return Zt})),r.d(t,"ExareUnvoluntaryReasonInfoFragmentDoc",(function(){return er})),r.d(t,"ChangeTravellerDataInfoFragmentDoc",(function(){return tr})),r.d(t,"FlightStatusAirportFragmentDoc",(function(){return rr})),r.d(t,"LocationGroupFragmentDoc",(function(){return nr})),r.d(t,"FlightStatusResponseFragmentDoc",(function(){return ir})),r.d(t,"AirportFragmentDoc",(function(){return ar})),r.d(t,"ScheduleResultSegmentSearchParameterFragmentDoc",(function(){return or})),r.d(t,"FullFlightsParametersFragmentDoc",(function(){return ur})),r.d(t,"AirlineFragmentDoc",(function(){return sr})),r.d(t,"ScheduleResultPointFragmentDoc",(function(){return cr})),r.d(t,"DurationFragmentDoc",(function(){return dr})),r.d(t,"SegmentStopFragmentDoc",(function(){return lr})),r.d(t,"FlightStaticInfoFragmentDoc",(function(){return fr})),r.d(t,"AircraftInfoParameterFragmentDoc",(function(){return mr})),r.d(t,"AircraftInfoCabinFragmentDoc",(function(){return pr})),r.d(t,"ScheduleResultSegmentFragmentDoc",(function(){return hr})),r.d(t,"ScheduleFlightDirectionsLegsFragmentDoc",(function(){return gr})),r.d(t,"FullFlightsScheduleFragmentDoc",(function(){return yr})),r.d(t,"InfoMessagesFragmentDoc",(function(){return vr})),r.d(t,"WeatherFragmentDoc",(function(){return Sr})),r.d(t,"FlightPointFragmentDoc",(function(){return Pr})),r.d(t,"SegmentFragmentDoc",(function(){return Dr})),r.d(t,"SegmentWithTransferFragmentDoc",(function(){return Cr})),r.d(t,"FareFamilyOptionFragmentDoc",(function(){return Fr})),r.d(t,"FareFamilyFragmentDoc",(function(){return Ir})),r.d(t,"PlainFlightFragmentDoc",(function(){return Tr})),r.d(t,"FareFamilyPriceFragmentDoc",(function(){return Or})),r.d(t,"ResultsLegFragmentDoc",(function(){return Ar})),r.d(t,"FareGroupOptionFragmentDoc",(function(){return $r})),r.d(t,"FareGroupFragmentDoc",(function(){return Er})),r.d(t,"SearchResultFlightDirectionsFragmentDoc",(function(){return Mr})),r.d(t,"ExarePriceDetailsFragmentDoc",(function(){return Nr})),r.d(t,"ExareVariantPriceInfoFragmentDoc",(function(){return Rr})),r.d(t,"LocationCodeFragmentDoc",(function(){return br})),r.d(t,"LocationSuggestionFragmentDoc",(function(){return xr})),r.d(t,"LocationSuggestionGroupFragmentDoc",(function(){return kr})),r.d(t,"ValidationRuleFragmentDoc",(function(){return Lr})),r.d(t,"TravellerParameterFragmentDoc",(function(){return wr})),r.d(t,"TravellerParameterEditableFragmentDoc",(function(){return Gr})),r.d(t,"PassengerSelectedGdsServicesProductFragmentDoc",(function(){return Qr})),r.d(t,"SelectedSeatFragmentDoc",(function(){return _r})),r.d(t,"SeatInfoBySegmentFragmentDoc",(function(){return Br})),r.d(t,"SeatServiceFragmentDoc",(function(){return zr})),r.d(t,"BaggageServiceFragmentDoc",(function(){return Ur})),r.d(t,"MealServicesFragmentDoc",(function(){return Vr})),r.d(t,"PriceFreezeFragmentDoc",(function(){return qr})),r.d(t,"VipServiceFragmentDoc",(function(){return Wr})),r.d(t,"GdsServiceFragmentDoc",(function(){return jr})),r.d(t,"IncludedGdsServicesFragmentDoc",(function(){return Kr})),r.d(t,"PassengerSelectedGdsServicesFragmentDoc",(function(){return Hr})),r.d(t,"PreselectedSeatFragmentDoc",(function(){return Yr})),r.d(t,"SubsidyInfoFragmentDoc",(function(){return Jr})),r.d(t,"TravellerDisabilityFragmentDoc",(function(){return Xr})),r.d(t,"PassengerFragmentDoc",(function(){return Zr})),r.d(t,"RefundTravellerFragmentDoc",(function(){return en})),r.d(t,"RefundPricesFragmentDoc",(function(){return tn})),r.d(t,"RefundOrderFragmentDoc",(function(){return rn})),r.d(t,"OrderWithLastRefundFragmentDoc",(function(){return nn})),r.d(t,"NASProductFareFragmentDoc",(function(){return an})),r.d(t,"NASProductFragmentDoc",(function(){return on})),r.d(t,"NASSelectedProductFragmentDoc",(function(){return un})),r.d(t,"RefundInfoFragmentDoc",(function(){return sn})),r.d(t,"FlightDirectionFragmentDoc",(function(){return cn})),r.d(t,"AviaPassengerFareFragmentDoc",(function(){return dn})),r.d(t,"ResultFareFragmentDoc",(function(){return ln})),r.d(t,"PaymentMethodFragmentDoc",(function(){return fn})),r.d(t,"CashMethodFragmentDoc",(function(){return mn})),r.d(t,"CardPaymentMethodFragmentDoc",(function(){return pn})),r.d(t,"TravellerVisaParameterFragmentDoc",(function(){return hn})),r.d(t,"TravellerSelectedServicesFragmentDoc",(function(){return gn})),r.d(t,"TravellerPreselectedServicesFragmentDoc",(function(){return yn})),r.d(t,"CheckinPassengerFragmentDoc",(function(){return vn})),r.d(t,"CheckinTravellerFareFamilyFragmentDoc",(function(){return Sn})),r.d(t,"CheckinInfoFragmentDoc",(function(){return Pn})),r.d(t,"CheckinSegmentFragmentDoc",(function(){return Dn})),r.d(t,"BaggageFragmentDoc",(function(){return Cn})),r.d(t,"InsuranceProgramExtraParamFragmentDoc",(function(){return Fn})),r.d(t,"InsuranceProgramFragmentDoc",(function(){return In})),r.d(t,"SelectedInsuranceFragmentDoc",(function(){return Tn})),r.d(t,"InsuranceProgramGroupFragmentDoc",(function(){return On})),r.d(t,"InsuranceFragmentDoc",(function(){return An})),r.d(t,"AeroexpressStationFragmentDoc",(function(){return $n})),r.d(t,"AeroexpressFareFragmentDoc",(function(){return En})),r.d(t,"TripFragmentDoc",(function(){return Mn})),r.d(t,"AeroExpressTicketFragmentDoc",(function(){return Nn})),r.d(t,"SelectedTripsFragmentDoc",(function(){return Rn})),r.d(t,"AeroexpressFragmentDoc",(function(){return bn})),r.d(t,"WidgetTravellersFragmentDoc",(function(){return xn})),r.d(t,"WidgetParametersFragmentDoc",(function(){return kn})),r.d(t,"WidgetAdditionalServiceFragmentDoc",(function(){return Ln})),r.d(t,"AdditionalServicesFragmentDoc",(function(){return wn})),r.d(t,"RowSeatFragmentDoc",(function(){return Gn})),r.d(t,"FlightSeatMapRowFragmentDoc",(function(){return Qn})),r.d(t,"FlightSeatMapSegmentFragmentDoc",(function(){return _n})),r.d(t,"FlightSeatMapServiceFragmentDoc",(function(){return Bn})),r.d(t,"FlightSeatMapFragmentDoc",(function(){return zn})),r.d(t,"PriceBreakdownDetailsFragmentDoc",(function(){return Un})),r.d(t,"PricePartsFragmentDoc",(function(){return Vn})),r.d(t,"CheckinOrderFragmentDoc",(function(){return qn})),r.d(t,"CustomerFragmentDoc",(function(){return Wn})),r.d(t,"ExareOrderFragmentDoc",(function(){return jn})),r.d(t,"ExistentEmailByFfpDataFragmentDoc",(function(){return Kn})),r.d(t,"PassengerFareFragmentDoc",(function(){return Hn})),r.d(t,"FlightsScheduleItemFragmentDoc",(function(){return Yn})),r.d(t,"GatewayPaymentFragmentDoc",(function(){return Jn})),r.d(t,"GooglePayMethodFragmentDoc",(function(){return Xn})),r.d(t,"InvoiceMethodFragmentDoc",(function(){return Zn})),r.d(t,"OrderPromoCodeInfoFragmentDoc",(function(){return ei})),r.d(t,"PaximizerSectionMessageFragmentDoc",(function(){return ti})),r.d(t,"PaximizerCommunicationSectionFragmentDoc",(function(){return ri})),r.d(t,"PaximizerTeaserClientFragmentDoc",(function(){return ni})),r.d(t,"PaximazerTeaserOrderInfoFragmentDoc",(function(){return ii})),r.d(t,"PaximizerTeaserMyAppealNotificationFragmentDoc",(function(){return ai})),r.d(t,"PaximizerTeaserPromoCodeNotificationFragmentDoc",(function(){return oi})),r.d(t,"PaximizerTeaserPromotionNotificationFragmentDoc",(function(){return ui})),r.d(t,"PaximizerCommunicationNotificationContentFragmentDoc",(function(){return si})),r.d(t,"PaximizerCommunicationOrderNotificationContentFragmentDoc",(function(){return ci})),r.d(t,"SearchParametersAirportFragmentDoc",(function(){return di})),r.d(t,"SearchParametersFragmentDoc",(function(){return li})),r.d(t,"ProfileDocumentFragmentDoc",(function(){return fi})),r.d(t,"TravellerProfileFragmentDoc",(function(){return mi})),r.d(t,"ProfileFragmentDoc",(function(){return pi})),r.d(t,"UserFragmentDoc",(function(){return hi})),r.d(t,"FlightFragmentDoc",(function(){return gi})),r.d(t,"ActializationResultsFragmentDoc",(function(){return yi})),r.d(t,"GdsServicesFragmentDoc",(function(){return vi})),r.d(t,"OrderAdditionalServicesFragmentDoc",(function(){return Si})),r.d(t,"OrderPriceFragmentDoc",(function(){return Pi})),r.d(t,"TravellerCardFfpInfoFragmentDoc",(function(){return Di})),r.d(t,"FfpInfoFragmentDoc",(function(){return Ci})),r.d(t,"ExchangeOrderFragmentDoc",(function(){return Fi})),r.d(t,"ChangeTravellerDataTravellerAvailabilityFragmentDoc",(function(){return Ii})),r.d(t,"ChangeTravellerDataOrderFragmentDoc",(function(){return Ti})),r.d(t,"ExareInfoFragmentDoc",(function(){return Oi})),r.d(t,"CheckoutOrderFragmentDoc",(function(){return Ai})),r.d(t,"AiPurchasePredictionFragmentDoc",(function(){return $i})),r.d(t,"GdsServicesWithPurchasePredictionsFragmentDoc",(function(){return Ei})),r.d(t,"ServicesWithPurchasePredictionFragmentDoc",(function(){return Mi})),r.d(t,"InsuranceProgramWithPurchasePredictionFragmentDoc",(function(){return Ni})),r.d(t,"OrderAdditionalServicesWithPredictionFragmentDoc",(function(){return Ri})),r.d(t,"GetAccountInfoDocument",(function(){return bi})),r.d(t,"useGetAccountInfoQuery",(function(){return xi})),r.d(t,"useGetAccountInfoLazyQuery",(function(){return ki})),r.d(t,"GetTravellersDocument",(function(){return Li})),r.d(t,"useGetTravellersQuery",(function(){return wi})),r.d(t,"useGetTravellersLazyQuery",(function(){return Gi})),r.d(t,"SaveMethodDocument",(function(){return Qi})),r.d(t,"useSaveMethodMutation",(function(){return _i})),r.d(t,"ConfirmMethodDocument",(function(){return Bi})),r.d(t,"useConfirmMethodMutation",(function(){return zi})),r.d(t,"RemoveAuthMethodDocument",(function(){return Ui})),r.d(t,"useRemoveAuthMethodMutation",(function(){return Vi})),r.d(t,"RemoveAccountDocument",(function(){return qi})),r.d(t,"useRemoveAccountMutation",(function(){return Wi})),r.d(t,"SetUserSettingsDocument",(function(){return ji})),r.d(t,"useSetUserSettingsMutation",(function(){return Ki})),r.d(t,"GetUserSettingsDocument",(function(){return Hi})),r.d(t,"useGetUserSettingsQuery",(function(){return Yi})),r.d(t,"useGetUserSettingsLazyQuery",(function(){return Ji})),r.d(t,"AccountExistenceDocument",(function(){return Xi})),r.d(t,"useAccountExistenceQuery",(function(){return Zi})),r.d(t,"useAccountExistenceLazyQuery",(function(){return ea})),r.d(t,"FfpAccountLogoutDocument",(function(){return ta})),r.d(t,"useFfpAccountLogoutMutation",(function(){return ra})),r.d(t,"FfpAccountHistoryDocument",(function(){return na})),r.d(t,"useFfpAccountHistoryQuery",(function(){return ia})),r.d(t,"useFfpAccountHistoryLazyQuery",(function(){return aa})),r.d(t,"GetUserProfileDocument",(function(){return oa})),r.d(t,"useGetUserProfileQuery",(function(){return ua})),r.d(t,"useGetUserProfileLazyQuery",(function(){return sa})),r.d(t,"GetOrdersListPaginatedDocument",(function(){return ca})),r.d(t,"useGetOrdersListPaginatedQuery",(function(){return da})),r.d(t,"useGetOrdersListPaginatedLazyQuery",(function(){return la})),r.d(t,"DeleteOrderDocument",(function(){return fa})),r.d(t,"useDeleteOrderMutation",(function(){return ma})),r.d(t,"ExistentEmailByFfpDocument",(function(){return pa})),r.d(t,"useExistentEmailByFfpQuery",(function(){return ha})),r.d(t,"useExistentEmailByFfpLazyQuery",(function(){return ga})),r.d(t,"AdditionalServicesDocument",(function(){return ya})),r.d(t,"useAdditionalServicesQuery",(function(){return va})),r.d(t,"useAdditionalServicesLazyQuery",(function(){return Sa})),r.d(t,"AircraftInfoDocument",(function(){return Pa})),r.d(t,"useAircraftInfoQuery",(function(){return Da})),r.d(t,"useAircraftInfoLazyQuery",(function(){return Ca})),r.d(t,"BookOrderDocument",(function(){return Fa})),r.d(t,"useBookOrderMutation",(function(){return Ia})),r.d(t,"CancelOrderDocument",(function(){return Ta})),r.d(t,"useCancelOrderMutation",(function(){return Oa})),r.d(t,"ChangeTravelerDataInfoDocument",(function(){return Aa})),r.d(t,"useChangeTravelerDataInfoQuery",(function(){return $a})),r.d(t,"useChangeTravelerDataInfoLazyQuery",(function(){return Ea})),r.d(t,"ChangeTravellerDataPriceDocument",(function(){return Ma})),r.d(t,"useChangeTravellerDataPriceQuery",(function(){return Na})),r.d(t,"useChangeTravellerDataPriceLazyQuery",(function(){return Ra})),r.d(t,"CheckinAddTravellerDocument",(function(){return ba})),r.d(t,"useCheckinAddTravellerMutation",(function(){return xa})),r.d(t,"CheckinCancelDocument",(function(){return ka})),r.d(t,"useCheckinCancelMutation",(function(){return La})),r.d(t,"CheckinCompleteDocument",(function(){return wa})),r.d(t,"useCheckinCompleteMutation",(function(){return Ga})),r.d(t,"CheckinCreateOrderDocument",(function(){return Qa})),r.d(t,"useCheckinCreateOrderMutation",(function(){return _a})),r.d(t,"CheckinDocumentsDocument",(function(){return Ba})),r.d(t,"useCheckinDocumentsQuery",(function(){return za})),r.d(t,"useCheckinDocumentsLazyQuery",(function(){return Ua})),r.d(t,"CheckinInfoDocument",(function(){return Va})),r.d(t,"useCheckinInfoQuery",(function(){return qa})),r.d(t,"useCheckinInfoLazyQuery",(function(){return Wa})),r.d(t,"CheckinLoadServicesDocument",(function(){return ja})),r.d(t,"useCheckinLoadServicesMutation",(function(){return Ka})),r.d(t,"CheckinRemoveTravellerDocument",(function(){return Ha})),r.d(t,"useCheckinRemoveTravellerMutation",(function(){return Ya})),r.d(t,"CheckinRulesDocument",(function(){return Ja})),r.d(t,"useCheckinRulesQuery",(function(){return Xa})),r.d(t,"useCheckinRulesLazyQuery",(function(){return Za})),r.d(t,"CheckinSaveOrderServicesDocument",(function(){return eo})),r.d(t,"useCheckinSaveOrderServicesMutation",(function(){return to})),r.d(t,"CheckinSendDocumentDocument",(function(){return ro})),r.d(t,"useCheckinSendDocumentMutation",(function(){return no})),r.d(t,"SetCheckinSetTravellersDataDocument",(function(){return io})),r.d(t,"useSetCheckinSetTravellersDataMutation",(function(){return ao})),r.d(t,"CheckinStartDocument",(function(){return oo})),r.d(t,"useCheckinStartMutation",(function(){return uo})),r.d(t,"CheckinUpdateTravellersDocument",(function(){return so})),r.d(t,"useCheckinUpdateTravellersMutation",(function(){return co})),r.d(t,"CitySuggestionsDocument",(function(){return lo})),r.d(t,"useCitySuggestionsQuery",(function(){return fo})),r.d(t,"useCitySuggestionsLazyQuery",(function(){return mo})),r.d(t,"CompletePaymentDocument",(function(){return po})),r.d(t,"useCompletePaymentMutation",(function(){return ho})),r.d(t,"ConfirmChangeTravellerOrderDocument",(function(){return go})),r.d(t,"useConfirmChangeTravellerOrderMutation",(function(){return yo})),r.d(t,"CreateChangeTravellerDataDocument",(function(){return vo})),r.d(t,"useCreateChangeTravellerDataMutation",(function(){return So})),r.d(t,"CreateExchangeDocument",(function(){return Po})),r.d(t,"useCreateExchangeMutation",(function(){return Do})),r.d(t,"CreateFfpAccountDocument",(function(){return Co})),r.d(t,"useCreateFfpAccountMutation",(function(){return Fo})),r.d(t,"CreateOrderDocument",(function(){return Io})),r.d(t,"useCreateOrderMutation",(function(){return To})),r.d(t,"GetAvailableDatesDocument",(function(){return Oo})),r.d(t,"useGetAvailableDatesQuery",(function(){return Ao})),r.d(t,"useGetAvailableDatesLazyQuery",(function(){return $o})),r.d(t,"FlightsMinPricesInPeriodDocument",(function(){return Eo})),r.d(t,"useFlightsMinPricesInPeriodQuery",(function(){return Mo})),r.d(t,"useFlightsMinPricesInPeriodLazyQuery",(function(){return No})),r.d(t,"FareGroupsCompareTableDocument",(function(){return Ro})),r.d(t,"useFareGroupsCompareTableQuery",(function(){return bo})),r.d(t,"useFareGroupsCompareTableLazyQuery",(function(){return xo})),r.d(t,"FareRulesDocument",(function(){return ko})),r.d(t,"useFareRulesQuery",(function(){return Lo})),r.d(t,"useFareRulesLazyQuery",(function(){return wo})),r.d(t,"FfpCompleteOrderDocument",(function(){return Go})),r.d(t,"useFfpCompleteOrderMutation",(function(){return Qo})),r.d(t,"FfpDefaultAccountDocument",(function(){return _o})),r.d(t,"useFfpDefaultAccountQuery",(function(){return Bo})),r.d(t,"useFfpDefaultAccountLazyQuery",(function(){return zo})),r.d(t,"FfpPassbookDocument",(function(){return Uo})),r.d(t,"useFfpPassbookQuery",(function(){return Vo})),r.d(t,"useFfpPassbookLazyQuery",(function(){return qo})),r.d(t,"FindGroupOrderDocument",(function(){return Wo})),r.d(t,"useFindGroupOrderMutation",(function(){return jo})),r.d(t,"FindOrderDocument",(function(){return Ko})),r.d(t,"useFindOrderMutation",(function(){return Ho})),r.d(t,"FindOrderAndRequestFfpMilesDocument",(function(){return Yo})),r.d(t,"useFindOrderAndRequestFfpMilesMutation",(function(){return Jo})),r.d(t,"FlightStatusLocationsDocument",(function(){return Xo})),r.d(t,"useFlightStatusLocationsQuery",(function(){return Zo})),r.d(t,"useFlightStatusLocationsLazyQuery",(function(){return eu})),r.d(t,"GetFlightsFromDocument",(function(){return tu})),r.d(t,"useGetFlightsFromQuery",(function(){return ru})),r.d(t,"useGetFlightsFromLazyQuery",(function(){return nu})),r.d(t,"FlightsScheduleDocument",(function(){return iu})),r.d(t,"useFlightsScheduleQuery",(function(){return au})),r.d(t,"useFlightsScheduleLazyQuery",(function(){return ou})),r.d(t,"FullFlightsScheduleDocument",(function(){return uu})),r.d(t,"useFullFlightsScheduleQuery",(function(){return su})),r.d(t,"useFullFlightsScheduleLazyQuery",(function(){return cu})),r.d(t,"GetCheckinOrderDocument",(function(){return du})),r.d(t,"useGetCheckinOrderQuery",(function(){return lu})),r.d(t,"useGetCheckinOrderLazyQuery",(function(){return fu})),r.d(t,"GetExchangePriceDocument",(function(){return mu})),r.d(t,"useGetExchangePriceQuery",(function(){return pu})),r.d(t,"useGetExchangePriceLazyQuery",(function(){return hu})),r.d(t,"GetExchangeVariantsDocument",(function(){return gu})),r.d(t,"useGetExchangeVariantsMutation",(function(){return yu})),r.d(t,"GetGeolocationDocument",(function(){return vu})),r.d(t,"useGetGeolocationQuery",(function(){return Su})),r.d(t,"useGetGeolocationLazyQuery",(function(){return Pu})),r.d(t,"GetOrdersListDocument",(function(){return Du})),r.d(t,"useGetOrdersListQuery",(function(){return Cu})),r.d(t,"useGetOrdersListLazyQuery",(function(){return Fu})),r.d(t,"GetTravellerProfilesDocument",(function(){return Iu})),r.d(t,"useGetTravellerProfilesQuery",(function(){return Tu})),r.d(t,"useGetTravellerProfilesLazyQuery",(function(){return Ou})),r.d(t,"LocationByUserPositionDocument",(function(){return Au})),r.d(t,"useLocationByUserPositionQuery",(function(){return $u})),r.d(t,"useLocationByUserPositionLazyQuery",(function(){return Eu})),r.d(t,"LocationsDocument",(function(){return Mu})),r.d(t,"useLocationsQuery",(function(){return Nu})),r.d(t,"useLocationsLazyQuery",(function(){return Ru})),r.d(t,"LogoutDocument",(function(){return bu})),r.d(t,"useLogoutMutation",(function(){return xu})),r.d(t,"MinPricesDocument",(function(){return ku})),r.d(t,"useMinPricesQuery",(function(){return Lu})),r.d(t,"useMinPricesLazyQuery",(function(){return wu})),r.d(t,"OrderDocumentDocument",(function(){return Gu})),r.d(t,"useOrderDocumentQuery",(function(){return Qu})),r.d(t,"useOrderDocumentLazyQuery",(function(){return _u})),r.d(t,"OrderDocumentsDocument",(function(){return Bu})),r.d(t,"useOrderDocumentsQuery",(function(){return zu})),r.d(t,"useOrderDocumentsLazyQuery",(function(){return Uu})),r.d(t,"OrderPriceQueryDocument",(function(){return Vu})),r.d(t,"useOrderPriceQueryQuery",(function(){return qu})),r.d(t,"useOrderPriceQueryLazyQuery",(function(){return Wu})),r.d(t,"OrderPromoCodeInfoDocument",(function(){return ju})),r.d(t,"useOrderPromoCodeInfoQuery",(function(){return Ku})),r.d(t,"useOrderPromoCodeInfoLazyQuery",(function(){return Hu})),r.d(t,"OrderSubsidyInfoDocument",(function(){return Yu})),r.d(t,"useOrderSubsidyInfoQuery",(function(){return Ju})),r.d(t,"useOrderSubsidyInfoLazyQuery",(function(){return Xu})),r.d(t,"GetPaxSectionsDocument",(function(){return Zu})),r.d(t,"useGetPaxSectionsQuery",(function(){return es})),r.d(t,"useGetPaxSectionsLazyQuery",(function(){return ts})),r.d(t,"GetPaxMyAppealTeasersDocument",(function(){return rs})),r.d(t,"useGetPaxMyAppealTeasersQuery",(function(){return ns})),r.d(t,"useGetPaxMyAppealTeasersLazyQuery",(function(){return is})),r.d(t,"GetPaxMyPromoCodeTeasersDocument",(function(){return as})),r.d(t,"useGetPaxMyPromoCodeTeasersQuery",(function(){return os})),r.d(t,"useGetPaxMyPromoCodeTeasersLazyQuery",(function(){return us})),r.d(t,"GetPaxOrderNotificationTeasersDocument",(function(){return ss})),r.d(t,"useGetPaxOrderNotificationTeasersQuery",(function(){return cs})),r.d(t,"useGetPaxOrderNotificationTeasersLazyQuery",(function(){return ds})),r.d(t,"GetPaxPromotionTeasersDocument",(function(){return ls})),r.d(t,"useGetPaxPromotionTeasersQuery",(function(){return fs})),r.d(t,"useGetPaxPromotionTeasersLazyQuery",(function(){return ms})),r.d(t,"GetPaxOrderNotificationTeasersContentDocument",(function(){return ps})),r.d(t,"useGetPaxOrderNotificationTeasersContentQuery",(function(){return hs})),r.d(t,"useGetPaxOrderNotificationTeasersContentLazyQuery",(function(){return gs})),r.d(t,"GetPaxPromotionTeasersContentDocument",(function(){return ys})),r.d(t,"useGetPaxPromotionTeasersContentQuery",(function(){return vs})),r.d(t,"useGetPaxPromotionTeasersContentLazyQuery",(function(){return Ss})),r.d(t,"GetPaxMyPromoCodeTeasersContentDocument",(function(){return Ps})),r.d(t,"useGetPaxMyPromoCodeTeasersContentQuery",(function(){return Ds})),r.d(t,"useGetPaxMyPromoCodeTeasersContentLazyQuery",(function(){return Cs})),r.d(t,"ReadCommunicationMessageDocument",(function(){return Fs})),r.d(t,"useReadCommunicationMessageQuery",(function(){return Is})),r.d(t,"useReadCommunicationMessageLazyQuery",(function(){return Ts})),r.d(t,"ReadCommunicationSectionMessageDocument",(function(){return Os})),r.d(t,"useReadCommunicationSectionMessageQuery",(function(){return As})),r.d(t,"useReadCommunicationSectionMessageLazyQuery",(function(){return $s})),r.d(t,"PaymentMethodsDocument",(function(){return Es})),r.d(t,"usePaymentMethodsQuery",(function(){return Ms})),r.d(t,"usePaymentMethodsLazyQuery",(function(){return Ns})),r.d(t,"GetPersonalDetailsDocument",(function(){return Rs})),r.d(t,"useGetPersonalDetailsQuery",(function(){return bs})),r.d(t,"useGetPersonalDetailsLazyQuery",(function(){return xs})),r.d(t,"GetDefaultPersonalDetailsDocument",(function(){return ks})),r.d(t,"useGetDefaultPersonalDetailsQuery",(function(){return Ls})),r.d(t,"useGetDefaultPersonalDetailsLazyQuery",(function(){return ws})),r.d(t,"SendPersonalDetailsDocument",(function(){return Gs})),r.d(t,"useSendPersonalDetailsMutation",(function(){return Qs})),r.d(t,"PnrHistoryDocument",(function(){return _s})),r.d(t,"usePnrHistoryQuery",(function(){return Bs})),r.d(t,"usePnrHistoryLazyQuery",(function(){return zs})),r.d(t,"ReCaptchaDocument",(function(){return Us})),r.d(t,"useReCaptchaQuery",(function(){return Vs})),r.d(t,"useReCaptchaLazyQuery",(function(){return qs})),r.d(t,"ReCaptchaVerifyDocument",(function(){return Ws})),r.d(t,"useReCaptchaVerifyMutation",(function(){return js})),r.d(t,"getRefundDocumentsDocument",(function(){return Ks})),r.d(t,"usegetRefundDocumentsQuery",(function(){return Hs})),r.d(t,"usegetRefundDocumentsLazyQuery",(function(){return Ys})),r.d(t,"createRefundOrderDocument",(function(){return Js})),r.d(t,"usecreateRefundOrderMutation",(function(){return Xs})),r.d(t,"getLastRefundDocument",(function(){return Zs})),r.d(t,"usegetLastRefundQuery",(function(){return ec})),r.d(t,"usegetLastRefundLazyQuery",(function(){return tc})),r.d(t,"refuseRefundOrderDocument",(function(){return rc})),r.d(t,"userefuseRefundOrderMutation",(function(){return nc})),r.d(t,"confirmRefundOrderDocument",(function(){return ic})),r.d(t,"useconfirmRefundOrderMutation",(function(){return ac})),r.d(t,"nasServicesRefundDocument",(function(){return oc})),r.d(t,"usenasServicesRefundMutation",(function(){return uc})),r.d(t,"RefuseExareDocument",(function(){return sc})),r.d(t,"useRefuseExareMutation",(function(){return cc})),r.d(t,"RefuseExchangeDocument",(function(){return dc})),r.d(t,"useRefuseExchangeMutation",(function(){return lc})),r.d(t,"RequestFfpMilesForOrderDocument",(function(){return fc})),r.d(t,"useRequestFfpMilesForOrderMutation",(function(){return mc})),r.d(t,"ResetOrderPaymentBlockDocument",(function(){return pc})),r.d(t,"useResetOrderPaymentBlockMutation",(function(){return hc})),r.d(t,"RestoreOrderDocument",(function(){return gc})),r.d(t,"useRestoreOrderMutation",(function(){return yc})),r.d(t,"CheckOrderAvailabilityDocument",(function(){return vc})),r.d(t,"useCheckOrderAvailabilityMutation",(function(){return Sc})),r.d(t,"SearchResultsDocument",(function(){return Pc})),r.d(t,"useSearchResultsQuery",(function(){return Dc})),r.d(t,"useSearchResultsLazyQuery",(function(){return Cc})),r.d(t,"RunSearchDocument",(function(){return Fc})),r.d(t,"useRunSearchMutation",(function(){return Ic})),r.d(t,"SaveClientInfoDocument",(function(){return Tc})),r.d(t,"useSaveClientInfoMutation",(function(){return Oc})),r.d(t,"SeatMapDocument",(function(){return Ac})),r.d(t,"useSeatMapQuery",(function(){return $c})),r.d(t,"useSeatMapLazyQuery",(function(){return Ec})),r.d(t,"SelectCheckinSegmentsDocument",(function(){return Mc})),r.d(t,"useSelectCheckinSegmentsMutation",(function(){return Nc})),r.d(t,"FFPNewFFPPasswordDocument",(function(){return Rc})),r.d(t,"useFFPNewFFPPasswordMutation",(function(){return bc})),r.d(t,"FFPResetPasswordCodeDocument",(function(){return xc})),r.d(t,"useFFPResetPasswordCodeMutation",(function(){return kc})),r.d(t,"GetServicesRefundInfoDocument",(function(){return Lc})),r.d(t,"useGetServicesRefundInfoQuery",(function(){return wc})),r.d(t,"useGetServicesRefundInfoLazyQuery",(function(){return Gc})),r.d(t,"SetOrderStatusDocument",(function(){return Qc})),r.d(t,"useSetOrderStatusMutation",(function(){return _c})),r.d(t,"SetSsrDataDocument",(function(){return Bc})),r.d(t,"useSetSsrDataMutation",(function(){return zc})),r.d(t,"AddTravellersDataDocument",(function(){return Uc})),r.d(t,"useAddTravellersDataMutation",(function(){return Vc})),r.d(t,"CreateNewCompanionDocument",(function(){return qc})),r.d(t,"useCreateNewCompanionMutation",(function(){return Wc})),r.d(t,"GetCompanionsDocument",(function(){return jc})),r.d(t,"useGetCompanionsQuery",(function(){return Kc})),r.d(t,"useGetCompanionsLazyQuery",(function(){return Hc})),r.d(t,"DefaultTravellerFieldsDocument",(function(){return Yc})),r.d(t,"useDefaultTravellerFieldsQuery",(function(){return Jc})),r.d(t,"useDefaultTravellerFieldsLazyQuery",(function(){return Xc})),r.d(t,"DocumentsValidationsDocument",(function(){return Zc})),r.d(t,"useDocumentsValidationsQuery",(function(){return ed})),r.d(t,"useDocumentsValidationsLazyQuery",(function(){return td})),r.d(t,"DeleteTravellerDocument",(function(){return rd})),r.d(t,"useDeleteTravellerMutation",(function(){return nd})),r.d(t,"UpdateTravellerDocument",(function(){return id})),r.d(t,"useUpdateTravellerMutation",(function(){return ad})),r.d(t,"UpdateCheckinOrderDocument",(function(){return od})),r.d(t,"useUpdateCheckinOrderMutation",(function(){return ud})),r.d(t,"UpdateOrderDocument",(function(){return sd})),r.d(t,"useUpdateOrderMutation",(function(){return cd})),r.d(t,"GetAviaOrdersListDocument",(function(){return dd})),r.d(t,"useGetAviaOrdersListQuery",(function(){return ld})),r.d(t,"useGetAviaOrdersListLazyQuery",(function(){return fd})),r.d(t,"OrderDocument",(function(){return md})),r.d(t,"useOrderQuery",(function(){return pd})),r.d(t,"useOrderLazyQuery",(function(){return hd})),r.d(t,"ActualizeOrderDocument",(function(){return gd})),r.d(t,"useActualizeOrderMutation",(function(){return yd})),r.d(t,"SendSecureCodeDocument",(function(){return vd})),r.d(t,"useSendSecureCodeMutation",(function(){return Sd})),r.d(t,"AuthenticateDocument",(function(){return Pd})),r.d(t,"useAuthenticateMutation",(function(){return Dd})),r.d(t,"SocialAuthDocument",(function(){return Cd})),r.d(t,"useSocialAuthQuery",(function(){return Fd})),r.d(t,"useSocialAuthLazyQuery",(function(){return Id})),r.d(t,"SaveOrderServicesDocument",(function(){return Td})),r.d(t,"useSaveOrderServicesMutation",(function(){return Od})),r.d(t,"OrderPriceBreakdownDocument",(function(){return Ad})),r.d(t,"useOrderPriceBreakdownQuery",(function(){return $d})),r.d(t,"useOrderPriceBreakdownLazyQuery",(function(){return Ed})),r.d(t,"HandleMetasearchRedirectDocument",(function(){return Md})),r.d(t,"useHandleMetasearchRedirectMutation",(function(){return Nd})),r.d(t,"ResendItineraryReceiptDocument",(function(){return Rd})),r.d(t,"useResendItineraryReceiptMutation",(function(){return bd})),r.d(t,"OrderServicesWithPurchasePredictionDocument",(function(){return xd})),r.d(t,"useOrderServicesWithPurchasePredictionQuery",(function(){return kd})),r.d(t,"useOrderServicesWithPurchasePredictionLazyQuery",(function(){return Ld}));var n=function(){return(n=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var i in t=arguments[r])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};Object.create;Object.create;function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}"function"==typeof Symbol&&null!=Symbol.iterator&&Symbol.iterator,"function"==typeof Symbol&&null!=Symbol.asyncIterator&&Symbol.asyncIterator;var a="function"==typeof Symbol&&null!=Symbol.toStringTag?Symbol.toStringTag:"@@toStringTag";function o(e,t){for(var r,n=/\r\n|[\n\r]/g,i=1,a=t+1;(r=n.exec(e.body))&&r.index<t;)i+=1,a=t+1-(r.index+r[0].length);return{line:i,column:a}}function u(e){return s(e.source,o(e.source,e.start))}function s(e,t){var r=e.locationOffset.column-1,n=d(r)+e.body,i=t.line-1,a=e.locationOffset.line-1,o=t.line+a,u=1===t.line?r:0,s=t.column+u,l="".concat(e.name,":").concat(o,":").concat(s,"\n"),f=n.split(/\r\n|[\n\r]/g),m=f[i];if(m.length>120){for(var p=Math.floor(s/80),h=s%80,g=[],y=0;y<m.length;y+=80)g.push(m.slice(y,y+80));return l+c([["".concat(o),g[0]]].concat(g.slice(1,p+1).map((function(e){return["",e]})),[[" ",d(h-1)+"^"],["",g[p+1]]]))}return l+c([["".concat(o-1),f[i-1]],["".concat(o),m],["",d(s-1)+"^"],["".concat(o+1),f[i+1]]])}function c(e){var t=e.filter((function(e){e[0];return void 0!==e[1]})),r=Math.max.apply(Math,t.map((function(e){return e[0].length})));return t.map((function(e){var t,n=e[0],i=e[1];return d(r-(t=n).length)+t+(i?" | "+i:" |")})).join("\n")}function d(e){return Array(e+1).join(" ")}function l(e){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function m(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function p(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function h(e,t){return!t||"object"!==l(t)&&"function"!=typeof t?g(e):t}function g(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function y(e){var t="function"==typeof Map?new Map:void 0;return(y=function(e){if(null===e||(r=e,-1===Function.toString.call(r).indexOf("[native code]")))return e;var r;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,n)}function n(){return v(e,arguments,D(this).constructor)}return n.prototype=Object.create(e.prototype,{constructor:{value:n,enumerable:!1,writable:!0,configurable:!0}}),P(n,e)})(e)}function v(e,t,r){return(v=S()?Reflect.construct:function(e,t,r){var n=[null];n.push.apply(n,t);var i=new(Function.bind.apply(e,n));return r&&P(i,r.prototype),i}).apply(null,arguments)}function S(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}function P(e,t){return(P=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function D(e){return(D=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var C=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&P(e,t)}(y,e);var t,r,n,c,d,l=(t=y,r=S(),function(){var e,n=D(t);if(r){var i=D(this).constructor;e=Reflect.construct(n,arguments,i)}else e=n.apply(this,arguments);return h(this,e)});function y(e,t,r,n,a,u,s){var c,d,p,v;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,y),(v=l.call(this,e)).name="GraphQLError",v.originalError=null!=u?u:void 0,v.nodes=F(Array.isArray(t)?t:t?[t]:void 0);for(var S=[],P=0,D=null!==(C=v.nodes)&&void 0!==C?C:[];P<D.length;P++){var C,I=D[P].loc;null!=I&&S.push(I)}S=F(S),v.source=null!=r?r:null===(c=S)||void 0===c?void 0:c[0].source,v.positions=null!=n?n:null===(d=S)||void 0===d?void 0:d.map((function(e){return e.start})),v.locations=n&&r?n.map((function(e){return o(r,e)})):null===(p=S)||void 0===p?void 0:p.map((function(e){return o(e.source,e.start)})),v.path=null!=a?a:void 0;var T,O=null==u?void 0:u.extensions;return null==s&&("object"==i(T=O)&&null!==T)?v.extensions=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){m(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({},O):v.extensions=null!=s?s:{},Object.defineProperties(g(v),{message:{enumerable:!0},locations:{enumerable:null!=v.locations},path:{enumerable:null!=v.path},extensions:{enumerable:null!=v.extensions&&Object.keys(v.extensions).length>0},name:{enumerable:!1},nodes:{enumerable:!1},source:{enumerable:!1},positions:{enumerable:!1},originalError:{enumerable:!1}}),null!=u&&u.stack?(Object.defineProperty(g(v),"stack",{value:u.stack,writable:!0,configurable:!0}),h(v)):(Error.captureStackTrace?Error.captureStackTrace(g(v),y):Object.defineProperty(g(v),"stack",{value:Error().stack,writable:!0,configurable:!0}),v)}return n=y,(c=[{key:"toString",value:function(){return function(e){var t=e.message;if(e.nodes)for(var r=0,n=e.nodes;r<n.length;r++){var i=n[r];i.loc&&(t+="\n\n"+u(i.loc))}else if(e.source&&e.locations)for(var a=0,o=e.locations;a<o.length;a++){var c=o[a];t+="\n\n"+s(e.source,c)}return t}(this)}},{key:a,get:function(){return"Object"}}])&&p(n.prototype,c),d&&p(n,d),y}(y(Error));function F(e){return void 0===e||0===e.length?void 0:e}function I(e,t,r){return new C("Syntax Error: ".concat(r),void 0,e,[t])}var T=Object.freeze({NAME:"Name",DOCUMENT:"Document",OPERATION_DEFINITION:"OperationDefinition",VARIABLE_DEFINITION:"VariableDefinition",SELECTION_SET:"SelectionSet",FIELD:"Field",ARGUMENT:"Argument",FRAGMENT_SPREAD:"FragmentSpread",INLINE_FRAGMENT:"InlineFragment",FRAGMENT_DEFINITION:"FragmentDefinition",VARIABLE:"Variable",INT:"IntValue",FLOAT:"FloatValue",STRING:"StringValue",BOOLEAN:"BooleanValue",NULL:"NullValue",ENUM:"EnumValue",LIST:"ListValue",OBJECT:"ObjectValue",OBJECT_FIELD:"ObjectField",DIRECTIVE:"Directive",NAMED_TYPE:"NamedType",LIST_TYPE:"ListType",NON_NULL_TYPE:"NonNullType",SCHEMA_DEFINITION:"SchemaDefinition",OPERATION_TYPE_DEFINITION:"OperationTypeDefinition",SCALAR_TYPE_DEFINITION:"ScalarTypeDefinition",OBJECT_TYPE_DEFINITION:"ObjectTypeDefinition",FIELD_DEFINITION:"FieldDefinition",INPUT_VALUE_DEFINITION:"InputValueDefinition",INTERFACE_TYPE_DEFINITION:"InterfaceTypeDefinition",UNION_TYPE_DEFINITION:"UnionTypeDefinition",ENUM_TYPE_DEFINITION:"EnumTypeDefinition",ENUM_VALUE_DEFINITION:"EnumValueDefinition",INPUT_OBJECT_TYPE_DEFINITION:"InputObjectTypeDefinition",DIRECTIVE_DEFINITION:"DirectiveDefinition",SCHEMA_EXTENSION:"SchemaExtension",SCALAR_TYPE_EXTENSION:"ScalarTypeExtension",OBJECT_TYPE_EXTENSION:"ObjectTypeExtension",INTERFACE_TYPE_EXTENSION:"InterfaceTypeExtension",UNION_TYPE_EXTENSION:"UnionTypeExtension",ENUM_TYPE_EXTENSION:"EnumTypeExtension",INPUT_OBJECT_TYPE_EXTENSION:"InputObjectTypeExtension"});var O="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):void 0;function A(e){var t=e.prototype.toJSON;"function"==typeof t||function(e,t){if(!Boolean(e))throw new Error(null!=t?t:"Unexpected invariant triggered.")}(0),e.prototype.inspect=t,O&&(e.prototype[O]=t)}var $=function(){function e(e,t,r){this.start=e.start,this.end=t.end,this.startToken=e,this.endToken=t,this.source=r}return e.prototype.toJSON=function(){return{start:this.start,end:this.end}},e}();A($);var E=function(){function e(e,t,r,n,i,a,o){this.kind=e,this.start=t,this.end=r,this.line=n,this.column=i,this.value=o,this.prev=a,this.next=null}return e.prototype.toJSON=function(){return{kind:this.kind,value:this.value,line:this.line,column:this.column}},e}();A(E);var M=Object.freeze({SOF:"<SOF>",EOF:"<EOF>",BANG:"!",DOLLAR:"$",AMP:"&",PAREN_L:"(",PAREN_R:")",SPREAD:"...",COLON:":",EQUALS:"=",AT:"@",BRACKET_L:"[",BRACKET_R:"]",BRACE_L:"{",PIPE:"|",BRACE_R:"}",NAME:"Name",INT:"Int",FLOAT:"Float",STRING:"String",BLOCK_STRING:"BlockString",COMMENT:"Comment"});function N(e){return(N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function R(e){return b(e,[])}function b(e,t){switch(N(e)){case"string":return JSON.stringify(e);case"function":return e.name?"[function ".concat(e.name,"]"):"[function]";case"object":return null===e?"null":function(e,t){if(-1!==t.indexOf(e))return"[Circular]";var r=[].concat(t,[e]),n=function(e){var t=e[String(O)];if("function"==typeof t)return t;if("function"==typeof e.inspect)return e.inspect}(e);if(void 0!==n){var i=n.call(e);if(i!==e)return"string"==typeof i?i:b(i,r)}else if(Array.isArray(e))return function(e,t){if(0===e.length)return"[]";if(t.length>2)return"[Array]";for(var r=Math.min(10,e.length),n=e.length-r,i=[],a=0;a<r;++a)i.push(b(e[a],t));1===n?i.push("... 1 more item"):n>1&&i.push("... ".concat(n," more items"));return"["+i.join(", ")+"]"}(e,r);return function(e,t){var r=Object.keys(e);if(0===r.length)return"{}";if(t.length>2)return"["+function(e){var t=Object.prototype.toString.call(e).replace(/^\[object /,"").replace(/]$/,"");if("Object"===t&&"function"==typeof e.constructor){var r=e.constructor.name;if("string"==typeof r&&""!==r)return r}return t}(e)+"]";return"{ "+r.map((function(r){return r+": "+b(e[r],t)})).join(", ")+" }"}(e,r)}(e,t);default:return String(e)}}function x(e,t){if(!Boolean(e))throw new Error(t)}var k=function(e,t){return e instanceof t};function L(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var w=function(){function e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"GraphQL request",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{line:1,column:1};"string"==typeof e||x(0,"Body must be a string. Received: ".concat(R(e),".")),this.body=e,this.name=t,this.locationOffset=r,this.locationOffset.line>0||x(0,"line in locationOffset is 1-indexed and must be positive."),this.locationOffset.column>0||x(0,"column in locationOffset is 1-indexed and must be positive.")}var t,r,n;return t=e,(r=[{key:a,get:function(){return"Source"}}])&&L(t.prototype,r),n&&L(t,n),e}();var G=Object.freeze({QUERY:"QUERY",MUTATION:"MUTATION",SUBSCRIPTION:"SUBSCRIPTION",FIELD:"FIELD",FRAGMENT_DEFINITION:"FRAGMENT_DEFINITION",FRAGMENT_SPREAD:"FRAGMENT_SPREAD",INLINE_FRAGMENT:"INLINE_FRAGMENT",VARIABLE_DEFINITION:"VARIABLE_DEFINITION",SCHEMA:"SCHEMA",SCALAR:"SCALAR",OBJECT:"OBJECT",FIELD_DEFINITION:"FIELD_DEFINITION",ARGUMENT_DEFINITION:"ARGUMENT_DEFINITION",INTERFACE:"INTERFACE",UNION:"UNION",ENUM:"ENUM",ENUM_VALUE:"ENUM_VALUE",INPUT_OBJECT:"INPUT_OBJECT",INPUT_FIELD_DEFINITION:"INPUT_FIELD_DEFINITION"});function Q(e){var t=e.split(/\r\n|[\n\r]/g),r=function(e){for(var t,r=!0,n=!0,i=0,a=null,o=0;o<e.length;++o)switch(e.charCodeAt(o)){case 13:10===e.charCodeAt(o+1)&&++o;case 10:r=!1,n=!0,i=0;break;case 9:case 32:++i;break;default:n&&!r&&(null===a||i<a)&&(a=i),n=!1}return null!==(t=a)&&void 0!==t?t:0}(e);if(0!==r)for(var n=1;n<t.length;n++)t[n]=t[n].slice(r);for(var i=0;i<t.length&&_(t[i]);)++i;for(var a=t.length;a>i&&_(t[a-1]);)--a;return t.slice(i,a).join("\n")}function _(e){for(var t=0;t<e.length;++t)if(" "!==e[t]&&"\t"!==e[t])return!1;return!0}var B=function(){function e(e){var t=new E(M.SOF,0,0,0,0,null);this.source=e,this.lastToken=t,this.token=t,this.line=1,this.lineStart=0}var t=e.prototype;return t.advance=function(){return this.lastToken=this.token,this.token=this.lookahead()},t.lookahead=function(){var e=this.token;if(e.kind!==M.EOF)do{var t;e=null!==(t=e.next)&&void 0!==t?t:e.next=U(this,e)}while(e.kind===M.COMMENT);return e},e}();function z(e){return isNaN(e)?M.EOF:e<127?JSON.stringify(String.fromCharCode(e)):'"\\u'.concat(("00"+e.toString(16).toUpperCase()).slice(-4),'"')}function U(e,t){for(var r=e.source,n=r.body,i=n.length,a=t.end;a<i;){var o=n.charCodeAt(a),u=e.line,s=1+a-e.lineStart;switch(o){case 65279:case 9:case 32:case 44:++a;continue;case 10:++a,++e.line,e.lineStart=a;continue;case 13:10===n.charCodeAt(a+1)?a+=2:++a,++e.line,e.lineStart=a;continue;case 33:return new E(M.BANG,a,a+1,u,s,t);case 35:return q(r,a,u,s,t);case 36:return new E(M.DOLLAR,a,a+1,u,s,t);case 38:return new E(M.AMP,a,a+1,u,s,t);case 40:return new E(M.PAREN_L,a,a+1,u,s,t);case 41:return new E(M.PAREN_R,a,a+1,u,s,t);case 46:if(46===n.charCodeAt(a+1)&&46===n.charCodeAt(a+2))return new E(M.SPREAD,a,a+3,u,s,t);break;case 58:return new E(M.COLON,a,a+1,u,s,t);case 61:return new E(M.EQUALS,a,a+1,u,s,t);case 64:return new E(M.AT,a,a+1,u,s,t);case 91:return new E(M.BRACKET_L,a,a+1,u,s,t);case 93:return new E(M.BRACKET_R,a,a+1,u,s,t);case 123:return new E(M.BRACE_L,a,a+1,u,s,t);case 124:return new E(M.PIPE,a,a+1,u,s,t);case 125:return new E(M.BRACE_R,a,a+1,u,s,t);case 34:return 34===n.charCodeAt(a+1)&&34===n.charCodeAt(a+2)?H(r,a,u,s,t,e):K(r,a,u,s,t);case 45:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:return W(r,a,o,u,s,t);case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 95:case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:case 105:case 106:case 107:case 108:case 109:case 110:case 111:case 112:case 113:case 114:case 115:case 116:case 117:case 118:case 119:case 120:case 121:case 122:return J(r,a,u,s,t)}throw I(r,a,V(o))}var c=e.line,d=1+a-e.lineStart;return new E(M.EOF,i,i,c,d,t)}function V(e){return e<32&&9!==e&&10!==e&&13!==e?"Cannot contain the invalid character ".concat(z(e),"."):39===e?"Unexpected single quote character ('), did you mean to use a double quote (\")?":"Cannot parse the unexpected character ".concat(z(e),".")}function q(e,t,r,n,i){var a,o=e.body,u=t;do{a=o.charCodeAt(++u)}while(!isNaN(a)&&(a>31||9===a));return new E(M.COMMENT,t,u,r,n,i,o.slice(t+1,u))}function W(e,t,r,n,i,a){var o=e.body,u=r,s=t,c=!1;if(45===u&&(u=o.charCodeAt(++s)),48===u){if((u=o.charCodeAt(++s))>=48&&u<=57)throw I(e,s,"Invalid number, unexpected digit after 0: ".concat(z(u),"."))}else s=j(e,s,u),u=o.charCodeAt(s);if(46===u&&(c=!0,u=o.charCodeAt(++s),s=j(e,s,u),u=o.charCodeAt(s)),69!==u&&101!==u||(c=!0,43!==(u=o.charCodeAt(++s))&&45!==u||(u=o.charCodeAt(++s)),s=j(e,s,u),u=o.charCodeAt(s)),46===u||function(e){return 95===e||e>=65&&e<=90||e>=97&&e<=122}(u))throw I(e,s,"Invalid number, expected digit but got: ".concat(z(u),"."));return new E(c?M.FLOAT:M.INT,t,s,n,i,a,o.slice(t,s))}function j(e,t,r){var n=e.body,i=t,a=r;if(a>=48&&a<=57){do{a=n.charCodeAt(++i)}while(a>=48&&a<=57);return i}throw I(e,i,"Invalid number, expected digit but got: ".concat(z(a),"."))}function K(e,t,r,n,i){for(var a,o,u,s,c=e.body,d=t+1,l=d,f=0,m="";d<c.length&&!isNaN(f=c.charCodeAt(d))&&10!==f&&13!==f;){if(34===f)return m+=c.slice(l,d),new E(M.STRING,t,d+1,r,n,i,m);if(f<32&&9!==f)throw I(e,d,"Invalid character within String: ".concat(z(f),"."));if(++d,92===f){switch(m+=c.slice(l,d-1),f=c.charCodeAt(d)){case 34:m+='"';break;case 47:m+="/";break;case 92:m+="\\";break;case 98:m+="\b";break;case 102:m+="\f";break;case 110:m+="\n";break;case 114:m+="\r";break;case 116:m+="\t";break;case 117:var p=(a=c.charCodeAt(d+1),o=c.charCodeAt(d+2),u=c.charCodeAt(d+3),s=c.charCodeAt(d+4),Y(a)<<12|Y(o)<<8|Y(u)<<4|Y(s));if(p<0){var h=c.slice(d+1,d+5);throw I(e,d,"Invalid character escape sequence: \\u".concat(h,"."))}m+=String.fromCharCode(p),d+=4;break;default:throw I(e,d,"Invalid character escape sequence: \\".concat(String.fromCharCode(f),"."))}l=++d}}throw I(e,d,"Unterminated string.")}function H(e,t,r,n,i,a){for(var o=e.body,u=t+3,s=u,c=0,d="";u<o.length&&!isNaN(c=o.charCodeAt(u));){if(34===c&&34===o.charCodeAt(u+1)&&34===o.charCodeAt(u+2))return d+=o.slice(s,u),new E(M.BLOCK_STRING,t,u+3,r,n,i,Q(d));if(c<32&&9!==c&&10!==c&&13!==c)throw I(e,u,"Invalid character within String: ".concat(z(c),"."));10===c?(++u,++a.line,a.lineStart=u):13===c?(10===o.charCodeAt(u+1)?u+=2:++u,++a.line,a.lineStart=u):92===c&&34===o.charCodeAt(u+1)&&34===o.charCodeAt(u+2)&&34===o.charCodeAt(u+3)?(d+=o.slice(s,u)+'"""',s=u+=4):++u}throw I(e,u,"Unterminated string.")}function Y(e){return e>=48&&e<=57?e-48:e>=65&&e<=70?e-55:e>=97&&e<=102?e-87:-1}function J(e,t,r,n,i){for(var a=e.body,o=a.length,u=t+1,s=0;u!==o&&!isNaN(s=a.charCodeAt(u))&&(95===s||s>=48&&s<=57||s>=65&&s<=90||s>=97&&s<=122);)++u;return new E(M.NAME,t,u,r,n,i,a.slice(t,u))}var X=function(){function e(e,t){var r=function(e){return k(e,w)}(e)?e:new w(e);this._lexer=new B(r),this._options=t}var t=e.prototype;return t.parseName=function(){var e=this.expectToken(M.NAME);return{kind:T.NAME,value:e.value,loc:this.loc(e)}},t.parseDocument=function(){var e=this._lexer.token;return{kind:T.DOCUMENT,definitions:this.many(M.SOF,this.parseDefinition,M.EOF),loc:this.loc(e)}},t.parseDefinition=function(){if(this.peek(M.NAME))switch(this._lexer.token.value){case"query":case"mutation":case"subscription":return this.parseOperationDefinition();case"fragment":return this.parseFragmentDefinition();case"schema":case"scalar":case"type":case"interface":case"union":case"enum":case"input":case"directive":return this.parseTypeSystemDefinition();case"extend":return this.parseTypeSystemExtension()}else{if(this.peek(M.BRACE_L))return this.parseOperationDefinition();if(this.peekDescription())return this.parseTypeSystemDefinition()}throw this.unexpected()},t.parseOperationDefinition=function(){var e=this._lexer.token;if(this.peek(M.BRACE_L))return{kind:T.OPERATION_DEFINITION,operation:"query",name:void 0,variableDefinitions:[],directives:[],selectionSet:this.parseSelectionSet(),loc:this.loc(e)};var t,r=this.parseOperationType();return this.peek(M.NAME)&&(t=this.parseName()),{kind:T.OPERATION_DEFINITION,operation:r,name:t,variableDefinitions:this.parseVariableDefinitions(),directives:this.parseDirectives(!1),selectionSet:this.parseSelectionSet(),loc:this.loc(e)}},t.parseOperationType=function(){var e=this.expectToken(M.NAME);switch(e.value){case"query":return"query";case"mutation":return"mutation";case"subscription":return"subscription"}throw this.unexpected(e)},t.parseVariableDefinitions=function(){return this.optionalMany(M.PAREN_L,this.parseVariableDefinition,M.PAREN_R)},t.parseVariableDefinition=function(){var e=this._lexer.token;return{kind:T.VARIABLE_DEFINITION,variable:this.parseVariable(),type:(this.expectToken(M.COLON),this.parseTypeReference()),defaultValue:this.expectOptionalToken(M.EQUALS)?this.parseValueLiteral(!0):void 0,directives:this.parseDirectives(!0),loc:this.loc(e)}},t.parseVariable=function(){var e=this._lexer.token;return this.expectToken(M.DOLLAR),{kind:T.VARIABLE,name:this.parseName(),loc:this.loc(e)}},t.parseSelectionSet=function(){var e=this._lexer.token;return{kind:T.SELECTION_SET,selections:this.many(M.BRACE_L,this.parseSelection,M.BRACE_R),loc:this.loc(e)}},t.parseSelection=function(){return this.peek(M.SPREAD)?this.parseFragment():this.parseField()},t.parseField=function(){var e,t,r=this._lexer.token,n=this.parseName();return this.expectOptionalToken(M.COLON)?(e=n,t=this.parseName()):t=n,{kind:T.FIELD,alias:e,name:t,arguments:this.parseArguments(!1),directives:this.parseDirectives(!1),selectionSet:this.peek(M.BRACE_L)?this.parseSelectionSet():void 0,loc:this.loc(r)}},t.parseArguments=function(e){var t=e?this.parseConstArgument:this.parseArgument;return this.optionalMany(M.PAREN_L,t,M.PAREN_R)},t.parseArgument=function(){var e=this._lexer.token,t=this.parseName();return this.expectToken(M.COLON),{kind:T.ARGUMENT,name:t,value:this.parseValueLiteral(!1),loc:this.loc(e)}},t.parseConstArgument=function(){var e=this._lexer.token;return{kind:T.ARGUMENT,name:this.parseName(),value:(this.expectToken(M.COLON),this.parseValueLiteral(!0)),loc:this.loc(e)}},t.parseFragment=function(){var e=this._lexer.token;this.expectToken(M.SPREAD);var t=this.expectOptionalKeyword("on");return!t&&this.peek(M.NAME)?{kind:T.FRAGMENT_SPREAD,name:this.parseFragmentName(),directives:this.parseDirectives(!1),loc:this.loc(e)}:{kind:T.INLINE_FRAGMENT,typeCondition:t?this.parseNamedType():void 0,directives:this.parseDirectives(!1),selectionSet:this.parseSelectionSet(),loc:this.loc(e)}},t.parseFragmentDefinition=function(){var e,t=this._lexer.token;return this.expectKeyword("fragment"),!0===(null===(e=this._options)||void 0===e?void 0:e.experimentalFragmentVariables)?{kind:T.FRAGMENT_DEFINITION,name:this.parseFragmentName(),variableDefinitions:this.parseVariableDefinitions(),typeCondition:(this.expectKeyword("on"),this.parseNamedType()),directives:this.parseDirectives(!1),selectionSet:this.parseSelectionSet(),loc:this.loc(t)}:{kind:T.FRAGMENT_DEFINITION,name:this.parseFragmentName(),typeCondition:(this.expectKeyword("on"),this.parseNamedType()),directives:this.parseDirectives(!1),selectionSet:this.parseSelectionSet(),loc:this.loc(t)}},t.parseFragmentName=function(){if("on"===this._lexer.token.value)throw this.unexpected();return this.parseName()},t.parseValueLiteral=function(e){var t=this._lexer.token;switch(t.kind){case M.BRACKET_L:return this.parseList(e);case M.BRACE_L:return this.parseObject(e);case M.INT:return this._lexer.advance(),{kind:T.INT,value:t.value,loc:this.loc(t)};case M.FLOAT:return this._lexer.advance(),{kind:T.FLOAT,value:t.value,loc:this.loc(t)};case M.STRING:case M.BLOCK_STRING:return this.parseStringLiteral();case M.NAME:switch(this._lexer.advance(),t.value){case"true":return{kind:T.BOOLEAN,value:!0,loc:this.loc(t)};case"false":return{kind:T.BOOLEAN,value:!1,loc:this.loc(t)};case"null":return{kind:T.NULL,loc:this.loc(t)};default:return{kind:T.ENUM,value:t.value,loc:this.loc(t)}}case M.DOLLAR:if(!e)return this.parseVariable()}throw this.unexpected()},t.parseStringLiteral=function(){var e=this._lexer.token;return this._lexer.advance(),{kind:T.STRING,value:e.value,block:e.kind===M.BLOCK_STRING,loc:this.loc(e)}},t.parseList=function(e){var t=this,r=this._lexer.token;return{kind:T.LIST,values:this.any(M.BRACKET_L,(function(){return t.parseValueLiteral(e)}),M.BRACKET_R),loc:this.loc(r)}},t.parseObject=function(e){var t=this,r=this._lexer.token;return{kind:T.OBJECT,fields:this.any(M.BRACE_L,(function(){return t.parseObjectField(e)}),M.BRACE_R),loc:this.loc(r)}},t.parseObjectField=function(e){var t=this._lexer.token,r=this.parseName();return this.expectToken(M.COLON),{kind:T.OBJECT_FIELD,name:r,value:this.parseValueLiteral(e),loc:this.loc(t)}},t.parseDirectives=function(e){for(var t=[];this.peek(M.AT);)t.push(this.parseDirective(e));return t},t.parseDirective=function(e){var t=this._lexer.token;return this.expectToken(M.AT),{kind:T.DIRECTIVE,name:this.parseName(),arguments:this.parseArguments(e),loc:this.loc(t)}},t.parseTypeReference=function(){var e,t=this._lexer.token;return this.expectOptionalToken(M.BRACKET_L)?(e=this.parseTypeReference(),this.expectToken(M.BRACKET_R),e={kind:T.LIST_TYPE,type:e,loc:this.loc(t)}):e=this.parseNamedType(),this.expectOptionalToken(M.BANG)?{kind:T.NON_NULL_TYPE,type:e,loc:this.loc(t)}:e},t.parseNamedType=function(){var e=this._lexer.token;return{kind:T.NAMED_TYPE,name:this.parseName(),loc:this.loc(e)}},t.parseTypeSystemDefinition=function(){var e=this.peekDescription()?this._lexer.lookahead():this._lexer.token;if(e.kind===M.NAME)switch(e.value){case"schema":return this.parseSchemaDefinition();case"scalar":return this.parseScalarTypeDefinition();case"type":return this.parseObjectTypeDefinition();case"interface":return this.parseInterfaceTypeDefinition();case"union":return this.parseUnionTypeDefinition();case"enum":return this.parseEnumTypeDefinition();case"input":return this.parseInputObjectTypeDefinition();case"directive":return this.parseDirectiveDefinition()}throw this.unexpected(e)},t.peekDescription=function(){return this.peek(M.STRING)||this.peek(M.BLOCK_STRING)},t.parseDescription=function(){if(this.peekDescription())return this.parseStringLiteral()},t.parseSchemaDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("schema");var r=this.parseDirectives(!0),n=this.many(M.BRACE_L,this.parseOperationTypeDefinition,M.BRACE_R);return{kind:T.SCHEMA_DEFINITION,description:t,directives:r,operationTypes:n,loc:this.loc(e)}},t.parseOperationTypeDefinition=function(){var e=this._lexer.token,t=this.parseOperationType();this.expectToken(M.COLON);var r=this.parseNamedType();return{kind:T.OPERATION_TYPE_DEFINITION,operation:t,type:r,loc:this.loc(e)}},t.parseScalarTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("scalar");var r=this.parseName(),n=this.parseDirectives(!0);return{kind:T.SCALAR_TYPE_DEFINITION,description:t,name:r,directives:n,loc:this.loc(e)}},t.parseObjectTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("type");var r=this.parseName(),n=this.parseImplementsInterfaces(),i=this.parseDirectives(!0),a=this.parseFieldsDefinition();return{kind:T.OBJECT_TYPE_DEFINITION,description:t,name:r,interfaces:n,directives:i,fields:a,loc:this.loc(e)}},t.parseImplementsInterfaces=function(){var e;if(!this.expectOptionalKeyword("implements"))return[];if(!0===(null===(e=this._options)||void 0===e?void 0:e.allowLegacySDLImplementsInterfaces)){var t=[];this.expectOptionalToken(M.AMP);do{t.push(this.parseNamedType())}while(this.expectOptionalToken(M.AMP)||this.peek(M.NAME));return t}return this.delimitedMany(M.AMP,this.parseNamedType)},t.parseFieldsDefinition=function(){var e;return!0===(null===(e=this._options)||void 0===e?void 0:e.allowLegacySDLEmptyFields)&&this.peek(M.BRACE_L)&&this._lexer.lookahead().kind===M.BRACE_R?(this._lexer.advance(),this._lexer.advance(),[]):this.optionalMany(M.BRACE_L,this.parseFieldDefinition,M.BRACE_R)},t.parseFieldDefinition=function(){var e=this._lexer.token,t=this.parseDescription(),r=this.parseName(),n=this.parseArgumentDefs();this.expectToken(M.COLON);var i=this.parseTypeReference(),a=this.parseDirectives(!0);return{kind:T.FIELD_DEFINITION,description:t,name:r,arguments:n,type:i,directives:a,loc:this.loc(e)}},t.parseArgumentDefs=function(){return this.optionalMany(M.PAREN_L,this.parseInputValueDef,M.PAREN_R)},t.parseInputValueDef=function(){var e=this._lexer.token,t=this.parseDescription(),r=this.parseName();this.expectToken(M.COLON);var n,i=this.parseTypeReference();this.expectOptionalToken(M.EQUALS)&&(n=this.parseValueLiteral(!0));var a=this.parseDirectives(!0);return{kind:T.INPUT_VALUE_DEFINITION,description:t,name:r,type:i,defaultValue:n,directives:a,loc:this.loc(e)}},t.parseInterfaceTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("interface");var r=this.parseName(),n=this.parseImplementsInterfaces(),i=this.parseDirectives(!0),a=this.parseFieldsDefinition();return{kind:T.INTERFACE_TYPE_DEFINITION,description:t,name:r,interfaces:n,directives:i,fields:a,loc:this.loc(e)}},t.parseUnionTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("union");var r=this.parseName(),n=this.parseDirectives(!0),i=this.parseUnionMemberTypes();return{kind:T.UNION_TYPE_DEFINITION,description:t,name:r,directives:n,types:i,loc:this.loc(e)}},t.parseUnionMemberTypes=function(){return this.expectOptionalToken(M.EQUALS)?this.delimitedMany(M.PIPE,this.parseNamedType):[]},t.parseEnumTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("enum");var r=this.parseName(),n=this.parseDirectives(!0),i=this.parseEnumValuesDefinition();return{kind:T.ENUM_TYPE_DEFINITION,description:t,name:r,directives:n,values:i,loc:this.loc(e)}},t.parseEnumValuesDefinition=function(){return this.optionalMany(M.BRACE_L,this.parseEnumValueDefinition,M.BRACE_R)},t.parseEnumValueDefinition=function(){var e=this._lexer.token,t=this.parseDescription(),r=this.parseName(),n=this.parseDirectives(!0);return{kind:T.ENUM_VALUE_DEFINITION,description:t,name:r,directives:n,loc:this.loc(e)}},t.parseInputObjectTypeDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("input");var r=this.parseName(),n=this.parseDirectives(!0),i=this.parseInputFieldsDefinition();return{kind:T.INPUT_OBJECT_TYPE_DEFINITION,description:t,name:r,directives:n,fields:i,loc:this.loc(e)}},t.parseInputFieldsDefinition=function(){return this.optionalMany(M.BRACE_L,this.parseInputValueDef,M.BRACE_R)},t.parseTypeSystemExtension=function(){var e=this._lexer.lookahead();if(e.kind===M.NAME)switch(e.value){case"schema":return this.parseSchemaExtension();case"scalar":return this.parseScalarTypeExtension();case"type":return this.parseObjectTypeExtension();case"interface":return this.parseInterfaceTypeExtension();case"union":return this.parseUnionTypeExtension();case"enum":return this.parseEnumTypeExtension();case"input":return this.parseInputObjectTypeExtension()}throw this.unexpected(e)},t.parseSchemaExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("schema");var t=this.parseDirectives(!0),r=this.optionalMany(M.BRACE_L,this.parseOperationTypeDefinition,M.BRACE_R);if(0===t.length&&0===r.length)throw this.unexpected();return{kind:T.SCHEMA_EXTENSION,directives:t,operationTypes:r,loc:this.loc(e)}},t.parseScalarTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("scalar");var t=this.parseName(),r=this.parseDirectives(!0);if(0===r.length)throw this.unexpected();return{kind:T.SCALAR_TYPE_EXTENSION,name:t,directives:r,loc:this.loc(e)}},t.parseObjectTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("type");var t=this.parseName(),r=this.parseImplementsInterfaces(),n=this.parseDirectives(!0),i=this.parseFieldsDefinition();if(0===r.length&&0===n.length&&0===i.length)throw this.unexpected();return{kind:T.OBJECT_TYPE_EXTENSION,name:t,interfaces:r,directives:n,fields:i,loc:this.loc(e)}},t.parseInterfaceTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("interface");var t=this.parseName(),r=this.parseImplementsInterfaces(),n=this.parseDirectives(!0),i=this.parseFieldsDefinition();if(0===r.length&&0===n.length&&0===i.length)throw this.unexpected();return{kind:T.INTERFACE_TYPE_EXTENSION,name:t,interfaces:r,directives:n,fields:i,loc:this.loc(e)}},t.parseUnionTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("union");var t=this.parseName(),r=this.parseDirectives(!0),n=this.parseUnionMemberTypes();if(0===r.length&&0===n.length)throw this.unexpected();return{kind:T.UNION_TYPE_EXTENSION,name:t,directives:r,types:n,loc:this.loc(e)}},t.parseEnumTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("enum");var t=this.parseName(),r=this.parseDirectives(!0),n=this.parseEnumValuesDefinition();if(0===r.length&&0===n.length)throw this.unexpected();return{kind:T.ENUM_TYPE_EXTENSION,name:t,directives:r,values:n,loc:this.loc(e)}},t.parseInputObjectTypeExtension=function(){var e=this._lexer.token;this.expectKeyword("extend"),this.expectKeyword("input");var t=this.parseName(),r=this.parseDirectives(!0),n=this.parseInputFieldsDefinition();if(0===r.length&&0===n.length)throw this.unexpected();return{kind:T.INPUT_OBJECT_TYPE_EXTENSION,name:t,directives:r,fields:n,loc:this.loc(e)}},t.parseDirectiveDefinition=function(){var e=this._lexer.token,t=this.parseDescription();this.expectKeyword("directive"),this.expectToken(M.AT);var r=this.parseName(),n=this.parseArgumentDefs(),i=this.expectOptionalKeyword("repeatable");this.expectKeyword("on");var a=this.parseDirectiveLocations();return{kind:T.DIRECTIVE_DEFINITION,description:t,name:r,arguments:n,repeatable:i,locations:a,loc:this.loc(e)}},t.parseDirectiveLocations=function(){return this.delimitedMany(M.PIPE,this.parseDirectiveLocation)},t.parseDirectiveLocation=function(){var e=this._lexer.token,t=this.parseName();if(void 0!==G[t.value])return t;throw this.unexpected(e)},t.loc=function(e){var t;if(!0!==(null===(t=this._options)||void 0===t?void 0:t.noLocation))return new $(e,this._lexer.lastToken,this._lexer.source)},t.peek=function(e){return this._lexer.token.kind===e},t.expectToken=function(e){var t=this._lexer.token;if(t.kind===e)return this._lexer.advance(),t;throw I(this._lexer.source,t.start,"Expected ".concat(ee(e),", found ").concat(Z(t),"."))},t.expectOptionalToken=function(e){var t=this._lexer.token;if(t.kind===e)return this._lexer.advance(),t},t.expectKeyword=function(e){var t=this._lexer.token;if(t.kind!==M.NAME||t.value!==e)throw I(this._lexer.source,t.start,'Expected "'.concat(e,'", found ').concat(Z(t),"."));this._lexer.advance()},t.expectOptionalKeyword=function(e){var t=this._lexer.token;return t.kind===M.NAME&&t.value===e&&(this._lexer.advance(),!0)},t.unexpected=function(e){var t=null!=e?e:this._lexer.token;return I(this._lexer.source,t.start,"Unexpected ".concat(Z(t),"."))},t.any=function(e,t,r){this.expectToken(e);for(var n=[];!this.expectOptionalToken(r);)n.push(t.call(this));return n},t.optionalMany=function(e,t,r){if(this.expectOptionalToken(e)){var n=[];do{n.push(t.call(this))}while(!this.expectOptionalToken(r));return n}return[]},t.many=function(e,t,r){this.expectToken(e);var n=[];do{n.push(t.call(this))}while(!this.expectOptionalToken(r));return n},t.delimitedMany=function(e,t){this.expectOptionalToken(e);var r=[];do{r.push(t.call(this))}while(this.expectOptionalToken(e));return r},e}();function Z(e){var t=e.value;return ee(e.kind)+(null!=t?' "'.concat(t,'"'):"")}function ee(e){return function(e){return e===M.BANG||e===M.DOLLAR||e===M.AMP||e===M.PAREN_L||e===M.PAREN_R||e===M.SPREAD||e===M.COLON||e===M.EQUALS||e===M.AT||e===M.BRACKET_L||e===M.BRACKET_R||e===M.BRACE_L||e===M.PIPE||e===M.BRACE_R}(e)?'"'.concat(e,'"'):e}var te=new Map,re=new Map,ne=!0,ie=!1;function ae(e){return e.replace(/[\s,]+/g," ").trim()}function oe(e){var t=new Set,r=[];return e.definitions.forEach((function(e){if("FragmentDefinition"===e.kind){var n=e.name.value,i=ae((o=e.loc).source.body.substring(o.start,o.end)),a=re.get(n);a&&!a.has(i)?ne&&console.warn("Warning: fragment with name "+n+" already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names"):a||re.set(n,a=new Set),a.add(i),t.has(i)||(t.add(i),r.push(e))}else r.push(e);var o})),n(n({},e),{definitions:r})}function ue(e){var t=ae(e);if(!te.has(t)){var r=function(e,t){return new X(e,t).parseDocument()}(e,{experimentalFragmentVariables:ie,allowLegacyFragmentVariables:ie});if(!r||"Document"!==r.kind)throw new Error("Not a valid GraphQL document.");te.set(t,function(e){var t=new Set(e.definitions);t.forEach((function(e){e.loc&&delete e.loc,Object.keys(e).forEach((function(r){var n=e[r];n&&"object"==typeof n&&t.add(n)}))}));var r=e.loc;return r&&(delete r.startToken,delete r.endToken),e}(oe(r)))}return te.get(t)}function se(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];"string"==typeof e&&(e=[e]);var n=e[0];return t.forEach((function(t,r){t&&"Document"===t.kind?n+=t.loc.source.body:n+=t,n+=e[r+1]})),ue(n)}var ce,de={gql:se,resetCaches:function(){te.clear(),re.clear()},disableFragmentWarnings:function(){ne=!1},enableExperimentalFragmentVariables:function(){ie=!0},disableExperimentalFragmentVariables:function(){ie=!1}};(ce=se||(se={})).gql=de.gql,ce.resetCaches=de.resetCaches,ce.disableFragmentWarnings=de.disableFragmentWarnings,ce.enableExperimentalFragmentVariables=de.enableExperimentalFragmentVariables,ce.disableExperimentalFragmentVariables=de.disableExperimentalFragmentVariables,se.default=se;var le,fe,me,pe,he,ge,ye,ve,Se,Pe,De,Ce,Fe,Ie,Te,Oe,Ae,$e,Ee,Me,Ne,Re,be,xe,ke,Le,we,Ge,Qe,_e,Be,ze,Ue,Ve,qe,We,je,Ke,He,Ye,Je,Xe,Ze,et,tt,rt,nt,it,at,ot,ut,st,ct,dt,lt,ft,mt,pt,ht,gt,yt,vt,St,Pt,Dt,Ct,Ft,It,Tt,Ot,At,$t,Et,Mt,Nt,Rt,bt,xt,kt,Lt,wt=se,Gt=r(0);!function(e){e.Success="Success",e.PriceIncreased="PriceIncreased",e.NotAvailable="NotAvailable"}(le||(le={})),function(e){e.standart="standart",e.child="child",e.buisness="buisness",e.roundTrip="roundTrip",e.full="full",e.full_advance="full_advance",e.family="family",e.business="business",e.roundtrip="roundtrip",e.family_roundtrip="family_roundtrip",e.couple="couple",e.couple_roundtrip="couple_roundtrip",e.business_roundtrip="business_roundtrip"}(fe||(fe={})),function(e){e.ToAirport="ToAirport",e.FromAirport="FromAirport",e.Roundtrip="Roundtrip"}(me||(me={})),function(e){e.AircraftType="AircraftType",e.Length="Length",e.Wingspan="Wingspan",e.CabinWidth="CabinWidth",e.PassengerCapacity="PassengerCapacity",e.MaxWeight="MaxWeight",e.CruisingSpeed="CruisingSpeed",e.MaxFlightAltitude="MaxFlightAltitude",e.MaxFlightRange="MaxFlightRange"}(pe||(pe={})),function(e){e.FreeMeal="FreeMeal",e.FreeSnack="FreeSnack",e.Alcohol="Alcohol",e.MainsPower="MainsPower",e.USBPower="USBPower",e.WiFi="WiFi",e.MediaScreen="MediaScreen",e.Headphones="Headphones",e.ExtraLegroom="ExtraLegroom"}(he||(he={})),function(e){e.Open="Open",e.Used="Used",e.Void="Void",e.CheckIn="CheckIn",e.Printed="Printed",e.Refunded="Refunded",e.Exchanged="Exchanged",e.Registered="Registered",e.Landed="Landed",e.Stoped="Stoped",e.PaperDocument="PaperDocument",e.Unavailable="Unavailable",e.ExchangedToPaper="ExchangedToPaper",e.Closed="Closed",e.AirportControl="AirportControl"}(ge||(ge={})),function(e){e.EMD="EMD",e.ET="ET"}(ye||(ye={})),function(e){e.ADT="ADT",e.CLD="CLD",e.INF="INF",e.INS="INS"}(ve||(ve={})),function(e){e.CarryOn="CarryOn",e.CheckedBaggage="CheckedBaggage",e.SportingEquipment="SportingEquipment",e.PetInHold="PetInHold",e.PetInCabin="PetInCabin",e.BaggageExcess="BaggageExcess",e.HandLuggageExcess="HandLuggageExcess",e.MusicalInstrument="MusicalInstrument",e.FishingEquipment="FishingEquipment",e.SurfingEquipment="SurfingEquipment",e.Ski="Ski",e.Bike="Bike",e.PetInHandCarrier="PetInHandCarrier"}(Se||(Se={})),function(e){e.PendingConfirmation="PendingConfirmation",e.Waiting="Waiting",e.Booked="Booked",e.Cancelled="Cancelled",e.Ticket="Ticket",e.Needconfirm="Needconfirm",e.Reject="Reject"}(Pe||(Pe={})),function(e){e.PNRLocator="PNRLocator",e.TicketNumber="TicketNumber"}(De||(De={})),function(e){e.BoardingPass="BoardingPass",e.BoardingPassCustom="BoardingPassCustom",e.QrCode="QrCode",e.AppleWallet="AppleWallet",e.ItineraryReceipt="ItineraryReceipt",e.AeroexpressTicket="AeroexpressTicket"}(Ce||(Ce={})),function(e){e.Expired="Expired",e.New="New",e.Started="Started",e.Confirmed="Confirmed"}(Fe||(Fe={})),function(e){e.ios="ios",e.android="android",e.browser="browser"}(Ie||(Ie={})),function(e){e.Passport="Passport",e.NationalPassport="NationalPassport",e.InternationalPassportRU="InternationalPassportRU",e.BirthRegDocument="BirthRegDocument",e.MilitaryIDCard="MilitaryIDCard",e.ResidencePermit="ResidencePermit",e.DocOfPassportLusing="DocOfPassportLusing",e.CertificateOfConvictedVacation="CertificateOfConvictedVacation",e.ReleaseCertificate="ReleaseCertificate",e.ServicePassport="ServicePassport",e.FederalParliamentDeputy="FederalParliamentDeputy",e.DiplomaticPassport="DiplomaticPassport",e.InternationalPassport="InternationalPassport",e.SeamanDocument="SeamanDocument",e.ReturnIntoSNGCountry="ReturnIntoSNGCountry"}(Te||(Te={})),function(e){e.chargeForUsedPart="chargeForUsedPart",e.agentChargeForExare="agentChargeForExare",e.taxesAdditionalCharge="taxesAdditionalCharge",e.fareAdditionalCharge="fareAdditionalCharge",e.chargeForTariffConditions="chargeForTariffConditions",e.airlineChargeForReturn="airlineChargeForReturn",e.airlineChargeForCancellation="airlineChargeForCancellation",e.taxesRetention="taxesRetention",e.agencyCharge="agencyCharge",e.subagencyCharge="subagencyCharge",e.paymentCharge="paymentCharge",e.agencyRounding="agencyRounding",e.chargeServiceAlphaInsurance="chargeServiceAlphaInsurance",e.chargeServiceSogazInsurance="chargeServiceSogazInsurance",e.chargeServiceErvInsurance="chargeServiceErvInsurance",e.chargeServiceAeroexpress="chargeServiceAeroexpress",e.chargeServiceServicePack="chargeServiceServicePack",e.chargeServiceSirenaInsurance="chargeServiceSirenaInsurance",e.additionalTaxesCharge="additionalTaxesCharge",e.alreadyRefundedMoney="alreadyRefundedMoney",e.fare="fare",e.sum="sum",e.gdsServiceFare="gdsServiceFare",e.other="other"}(Oe||(Oe={})),function(e){e.FlightCancellationOrDelay="FlightCancellationOrDelay",e.Rerouting="Rerouting",e.FlightOperationOutOfSchedule="FlightOperationOutOfSchedule",e.SeatUnavailability="SeatUnavailability",e.EnduringSecurityScreening="EnduringSecurityScreening",e.FailedEnsureConnectionOfFlights="FailedEnsureConnectionOfFlights",e.Illness="Illness",e.FailedToProvideServices="FailedToProvideServices",e.FailedToIssueTicketAppropriately="FailedToIssueTicketAppropriately",e.FlightNumberChange="FlightNumberChange",e.FlightRetimed="FlightRetimed",e.FlightCancelled="FlightCancelled",e.PermanentWithdrawalOfService="PermanentWithdrawalOfService",e.LaborDispute="LaborDispute",e.Bereavement="Bereavement",e.UnableToObtainNecessaryDocumentation="UnableToObtainNecessaryDocumentation",e.Strike="Strike",e.Weather="Weather",e.NaturalDisaster="NaturalDisaster",e.UnacceptableReaccommodation="UnacceptableReaccommodation",e.Misspell="Misspell",e.DocumentReplacement="DocumentReplacement",e.OtherCases="OtherCases"}(Ae||(Ae={})),function(e){e.VisaDenial="VisaDenial",e.MedicalCertificate="MedicalCertificate",e.DeathCertificate="DeathCertificate",e.FlightProblems="FlightProblems",e.Other="Other"}($e||($e={})),function(e){e.Off="Off",e.AnyManual="AnyManual",e.CompelledManual="CompelledManual",e.AnyCompelled="AnyCompelled"}(Ee||(Ee={})),function(e){e.InProcess="InProcess",e.NeedConfirm="NeedConfirm",e.AwaitingPayment="AwaitingPayment",e.Finished="Finished",e.Rejected="Rejected",e.Refused="Refused",e.TimelimitExpired="TimelimitExpired"}(Me||(Me={})),function(e){e.CarryOn="CarryOn",e.Baggage="Baggage",e.SeatRegistration="SeatRegistration",e.OnlineRegistration="OnlineRegistration",e.VipService="VipService",e.Miles="Miles",e.Meal="Meal",e.Refundable="Refundable",e.Exchangeable="Exchangeable",e.SportsEquipment="SportsEquipment"}(Ne||(Ne={})),function(e){e.Pay="Pay",e.Free="Free",e.NotAvailable="NotAvailable"}(Re||(Re={})),function(e){e.LatinFirstName="LatinFirstName",e.LatinLastName="LatinLastName",e.LatinMiddleName="LatinMiddleName",e.FirstName="FirstName",e.LastName="LastName",e.MiddleName="MiddleName",e.Phone="Phone",e.Email="Email",e.DocNumber="DocNumber",e.DocExpiryDate="DocExpiryDate",e.BirthDate="BirthDate",e.DocType="DocType",e.Gender="Gender",e.DocIssued="DocIssued",e.DocIssuedBy="DocIssuedBy",e.City="City",e.CityID="CityID",e.Country="Country"}(be||(be={})),function(e){e.pdf="pdf",e.png="png"}(xe||(xe={})),function(e){e.Economy="Economy",e.Business="Business",e.First="First",e.Miles="Miles"}(ke||(ke={})),function(e){e.Confirmed="Confirmed",e.Canceled="Canceled",e.Requested="Requested",e.WaitList="WaitList"}(Le||(Le={})),function(e){e.ScheduledDeparture="ScheduledDeparture",e.Canceled="Canceled",e.Delayed="Delayed",e.Departed="Departed",e.ForwardToReserved="ForwardToReserved",e.Landed="Landed",e.DataPending="DataPending",e.LandedAtReserved="LandedAtReserved",e.DepartedFromReserve="DepartedFromReserve"}(we||(we={})),function(e){e.New="New",e.Booked="Booked",e.Canceled="Canceled",e.Ticketed="Ticketed",e.Rejected="Rejected",e.Requested="Requested",e.Problematic="Problematic"}(Ge||(Ge={})),function(e){e.byRfiscPerOrder="byRfiscPerOrder",e.byRfiscPerSegment="byRfiscPerSegment",e.byTypePerOrder="byTypePerOrder",e.byTypePerSegment="byTypePerSegment",e.bySubTypePerOrder="bySubTypePerOrder",e.bySubTypePerSegment="bySubTypePerSegment"}(Qe||(Qe={})),function(e){e.PriorityBoarding="PriorityBoarding",e.PriceFreeze="PriceFreeze",e.BusinessLounge="BusinessLounge",e.BusinessLoungeInternational="BusinessLoungeInternational",e.UnknownSubtype="UnknownSubtype",e.CapsuleHotel="CapsuleHotel",e.BaggageDelivery="BaggageDelivery",e.ExtraSeat="ExtraSeat",e.Subscription="Subscription",e.Upgrade="Upgrade",e.Store="Store",e.GroundTransportation="GroundTransportation",e.SMS="SMS"}(_e||(_e={})),function(e){e.Male="Male",e.Female="Female",e.Other="Other"}(Be||(Be={})),function(e){e.default="default",e.flight="flight",e.stopPoint="stopPoint",e.flightPrice="flightPrice",e.upsaleRight="upsaleRight",e.meal="meal",e.baggage="baggage",e.seat="seat",e.serviceTop="serviceTop",e.serviceBottom="serviceBottom",e.tariffCardBottom="tariffCardBottom",e.bookingAncillaries="bookingAncillaries",e.bookingTop="bookingTop",e.upsaleTop="upsaleTop",e.upsaleEconomy="upsaleEconomy",e.upsaleBusiness="upsaleBusiness",e.upsaleEconomyRight="upsaleEconomyRight",e.upsaleBusinessRight="upsaleBusinessRight"}(ze||(ze={})),function(e){e.Promo="Promo",e.Info="Info",e.Warning="Warning",e.SubscriptionSaving="SubscriptionSaving",e.HtmlContent="HtmlContent"}(Ue||(Ue={})),function(e){e.FlightConfirmation="FlightConfirmation",e.TicketPrice="TicketPrice",e.FlightDelayCancel="FlightDelayCancel",e.FlightPriceInRf="FlightPriceInRf",e.PriceOnTerritoryOfRf="PriceOnTerritoryOfRf",e.GeneralRouteLength="GeneralRouteLength",e.BoardingPassDublicat="BoardingPassDublicat",e.NoFlight="NoFlight",e.NoPrice="NoPrice",e.Other="Other"}(Ve||(Ve={})),function(e){e.AlphaInsurance="AlphaInsurance",e.SirenaInsurance="SirenaInsurance",e.Vsk="Vsk"}(qe||(qe={})),function(e){e.AdditionalCities="AdditionalCities",e.Nearest="Nearest",e.Popular="Popular"}(We||(We={})),function(e){e.AdditionalCities="AdditionalCities",e.Nearest="Nearest",e.Popular="Popular",e.Country="Country"}(je||(je={})),function(e){e.Default="Default",e.City="City",e.Country="Country",e.Airport="Airport",e.IataCode="IataCode",e.AlternateName="AlternateName",e.ProbableName="ProbableName"}(Ke||(Ke={})),function(e){e.Phone="Phone",e.Email="Email",e.Facebook="Facebook",e.Google="Google",e.Vkontakte="Vkontakte",e.AppleID="AppleID",e.TinkoffID="TinkoffID",e.Telegram="Telegram",e.SberID="SberID",e.FFP="FFP",e.Host="Host",e.FirebasePhone="FirebasePhone",e.GoogleOneTap="GoogleOneTap"}(He||(He={})),function(e){e.lounge="lounge",e.fast_track="fast_track",e.vip="vip",e.meet_and_greet="meet_and_greet"}(Ye||(Ye={})),function(e){e.Departure="Departure",e.Arrival="Arrival"}(Je||(Je={})),function(e){e.Lounge="Lounge"}(Xe||(Xe={})),function(e){e.New="New",e.Confirmed="Confirmed",e.Cancelled="Cancelled",e.Refunded="Refunded"}(Ze||(Ze={})),function(e){e.Facebook="Facebook",e.Google="Google",e.Vkontakte="Vkontakte",e.AppleID="AppleID",e.TinkoffID="TinkoffID",e.Telegram="Telegram",e.SberID="SberID"}(et||(et={})),function(e){e.Baggage="Baggage",e.Meal="Meal",e.Seat="Seat",e.Vip="Vip",e.Misc="Misc",e.BusinessLounge="BusinessLounge"}(tt||(tt={})),function(e){e.GdsServices="GdsServices"}(rt||(rt={})),function(e){e.ItineraryReceipt="ItineraryReceipt",e.ItineraryReceiptData="ItineraryReceiptData",e.AeroexpressTicket="AeroexpressTicket",e.NASTicket="NASTicket",e.EveryTravelTicket="EveryTravelTicket",e.EMD="EMD",e.All="All"}(nt||(nt={})),function(e){e.Active="Active",e.Flown="Flown"}(it||(it={})),function(e){e.New="New",e.Booked="Booked",e.Confirmed="Confirmed",e.Cancelled="Cancelled",e.Problematic="Problematic"}(at||(at={})),function(e){e.Adult="Adult",e.Child="Child",e.Infant="Infant"}(ot||(ot={})),function(e){e.my_appeals="my_appeals",e.chat="chat",e.promotions="promotions",e.order_notifications="order_notifications",e.my_promo_codes="my_promo_codes"}(ut||(ut={})),function(e){e.MoneyCarePro="MoneyCarePro",e.PayLate="PayLate",e.Idram="Idram",e.YandexPay="YandexPay"}(st||(st={})),function(e){e.None="None",e.Part="Part",e.Full="Full",e.Penalty="Penalty",e.PenaltyPart="PenaltyPart",e.PenaltyFull="PenaltyFull"}(ct||(ct={})),function(e){e.MainService="MainService",e.Aeroexpress="Aeroexpress",e.GdsService="GdsService",e.Insurance="Insurance",e.Charge="Charge",e.Refund="Refund"}(dt||(dt={})),function(e){e.LatinFirstName="LatinFirstName",e.LatinLastName="LatinLastName",e.LatinMiddleName="LatinMiddleName",e.LastName="LastName",e.FirstName="FirstName",e.MiddleName="MiddleName",e.BirthDate="BirthDate",e.Gender="Gender",e.Nationality="Nationality",e.DocType="DocType",e.DocNumber="DocNumber",e.DocExpiryDate="DocExpiryDate",e.Phone="Phone",e.Email="Email",e.LoyaltyAirline="LoyaltyAirline",e.LoyaltyNumber="LoyaltyNumber",e.Country="Country"}(lt||(lt={})),function(e){e.OW="OW",e.RT="RT",e.CR="CR"}(ft||(ft={})),function(e){e.Standart="Standart",e.Standard="Standard",e.Preferred="Preferred",e.Comfort="Comfort"}(mt||(mt={})),function(e){e.WithAnimals="WithAnimals"}(pt||(pt={})),function(e){e.SeriouslyIllPeople="SeriouslyIllPeople",e.PassengersOnStretchers="PassengersOnStretchers",e.VisuallyOrHearingImpaired="VisuallyOrHearingImpaired",e.NeedOxygenEquipment="NeedOxygenEquipment",e.PassengersUnder18="PassengersUnder18",e.WithAnimals="WithAnimals",e.PregnantWomen="PregnantWomen",e.DoNotSpeakTheLanguage="DoNotSpeakTheLanguage",e.RequiringAccompany="RequiringAccompany",e.Infant="Infant",e.EscortedChildren="EscortedChildren",e.ElderlyPerson="ElderlyPerson",e.Unaccompanied="Unaccompanied"}(ht||(ht={})),function(e){e.extraSeat="extraSeat",e.common="common",e.cabinBaggage="cabinBaggage"}(gt||(gt={})),function(e){e.Integer="Integer",e.String="String",e.Bool="Bool"}(yt||(yt={})),function(e){e.Id="Id"}(vt||(vt={})),function(e){e.ASC="ASC",e.DESC="DESC"}(St||(St={})),function(e){e.Confirmed="Confirmed",e.NeedConfirmation="NeedConfirmation",e.NotConfirmed="NotConfirmed",e.Canceled="Canceled",e.Flew="Flew",e.OnRequest="OnRequest",e.Rejected="Rejected"}(Pt||(Pt={})),function(e){e.LargeFamily="LargeFamily",e.Moroshka="Moroshka",e.Other="Other"}(Dt||(Dt={})),function(e){e.LeftSide="LeftSide",e.RightSide="RightSide",e.NoneSide="NoneSide"}(Ct||(Ct={})),function(e){e.Celsius="Celsius",e.Fahrenheit="Fahrenheit",e.Kelvin="Kelvin"}(Ft||(Ft={})),function(e){e.ToAirport="ToAirport",e.Airport="Airport",e.Boarding="Boarding",e.Flight="Flight",e.Landing="Landing",e.FromAirport="FromAirport",e.ToFromAirport="ToFromAirport"}(It||(It={})),function(e){e.LastName="LastName",e.FirstName="FirstName",e.MiddleName="MiddleName",e.BirthDate="BirthDate",e.Gender="Gender",e.Nationality="Nationality",e.DocType="DocType",e.DocNumber="DocNumber",e.DocExpiryDate="DocExpiryDate",e.Phone="Phone",e.Email="Email",e.LoyaltyAirline="LoyaltyAirline",e.LoyaltyNumber="LoyaltyNumber",e.KzIinDocument="KzIinDocument",e.Country="Country",e.LinkedTraveller="LinkedTraveller",e.PromoCode="PromoCode",e.AccompanyingPersonName="AccompanyingPersonName",e.AccompanyingPersonTicketNumber="AccompanyingPersonTicketNumber",e.Citizenship="Citizenship"}(Tt||(Tt={})),function(e){e.FullMatch="FullMatch",e.Mismatch="Mismatch",e.PartialMatch="PartialMatch"}(Ot||(Ot={})),function(e){e.ApplicableCountry="ApplicableCountry",e.BirthPlace="BirthPlace",e.IssueDate="IssueDate",e.IssuePlace="IssuePlace",e.Number="Number"}(At||(At={})),function(e){e.red="red",e.silver="silver",e.gold="gold",e.platinum="platinum",e.nickel="nickel",e.base="base",e.bronze="bronze",e.basic="basic",e.standart="standart",e.diamond="diamond",e.vip="vip",e.classic="classic",e.compliment="compliment",e.appreciation="appreciation",e.gratitude="gratitude",e.temporary="temporary"}($t||($t={})),function(e){e.LatinFirstName="LatinFirstName",e.LatinLastName="LatinLastName",e.LatinMiddleName="LatinMiddleName",e.FirstName="FirstName",e.LastName="LastName",e.MiddleName="MiddleName",e.Phone="Phone",e.Email="Email",e.BirthDate="BirthDate"}(Et||(Et={})),function(e){e.Latin="Latin",e.Cyrillic="Cyrillic"}(Mt||(Mt={})),function(e){e.Landing="Landing",e.Order="Order",e.Account="Account",e.Upsale="Upsale"}(Nt||(Nt={})),function(e){e.aviaTicket="aviaTicket",e.aviaService="aviaService"}(Rt||(Rt={})),function(e){e.AutoEmulation="AutoEmulation",e.Active="Active",e.Cancel="Cancel",e.Pending="Pending",e.Freeze="Freeze"}(bt||(bt={})),function(e){e.Thunderstorm="Thunderstorm",e.Drizzle="Drizzle",e.Rain="Rain",e.Snow="Snow",e.Clear="Clear",e.Clouds="Clouds",e.Unknown="Unknown"}(xt||(xt={})),function(e){e.Monday="Monday",e.Tuesday="Tuesday",e.Wednesday="Wednesday",e.Thursday="Thursday",e.Friday="Friday",e.Saturday="Saturday",e.Sunday="Sunday"}(kt||(kt={})),function(e){e.EveryTravel="EveryTravel"}(Lt||(Lt={}));const Qt=wt`
	fragment AccountSegment on FlightSegment {
		id
		arrival {
			airport {
				id
				iata
				city {
					name
					images {
						panorama {
							url
						}
					}
				}
			}
			date
			time
		}
		departure {
			airport {
				id
				iata
				city {
					name
					images {
						panorama {
							url
						}
					}
				}
			}
			date
			time
		}
	}
`,_t=wt`
	fragment Money on Money {
		amount
		currency
	}
`,Bt=wt`
	fragment AccountOrdersList on AviaOrder {
		id
		timelimit
		accessCode
		canAddServices
		canRemoveServices
		servicesFallbackURL
		locator
		paymentStatus
		status
		travellers {
			values {
				type
				value
			}
		}
		flight {
			id
			segmentGroups {
				segments {
					...AccountSegment
				}
			}
		}
		price {
			total {
				...Money
			}
		}
	}
	${Qt}
	${_t}
`,zt=wt`
	fragment CardHolder on FfpCardHolder {
		firstName
		lastName
		middleName
	}
`,Ut=wt`
	fragment UserFfpInfo on UserFfpInfo {
		cardHolder {
			...CardHolder
		}
		cardNumber
		numberOfMiles
		numberOfQualifyingMiles
		numberOfFlownSegments
		milesForNextLevel
		currentLevel
		availableLevels
		currentLevelMaxMiles
		currentLevelMaxSegments
		segmentsForNextLevel
		registerEmail
	}
	${zt}
`,Vt=wt`
	fragment AuthMethod on AuthMethods {
		id
		value
		confirmed
		loginType
	}
`,qt=wt`
	fragment NameValueMap on TravellerParameter {
		name
		value
	}
`,Wt=wt`
	fragment UserProfileInfo on UserProfile {
		id
		gender
		values {
			...NameValueMap
		}
	}
	${qt}
`,jt=wt`
	fragment UserProfileFfpInfo on UserFfpInfo {
		cardNumber
		currentLevel
		numberOfMiles
	}
`,Kt=wt`
	fragment OptionParameter on OptionParameter {
		label
		value
		priority
	}
`,Ht=wt`
	fragment IValidationRule on IValidationRule {
		with {
			name
			value
		}
		required
		hidden
		label
		hint
		placeholder
		minDate
		maxDate
		maxLength
		regExp {
			pattern
			error
		}
		options {
			...OptionParameter
		}
	}
	${Kt}
`,Yt=wt`
	fragment WithParameter on WithParameter {
		name
		value
		type
	}
`,Jt=wt`
	fragment ChangeValidationRule on ChangeTravellerDataValidationRule {
		...IValidationRule
		with {
			...WithParameter
		}
		maxEditDistance
	}
	${Ht}
	${Yt}
`,Xt=wt`
	fragment ChangeTravellerParameter on ChangeTravellerDataTravellerParameter {
		type
		name
		value
		validationRules {
			...ChangeValidationRule
		}
	}
	${Jt}
`,Zt=wt`
	fragment ChangeTravellerDataTravellerInfo on ChangeTravellerDataTravellerInfo {
		id
		values {
			...ChangeTravellerParameter
		}
	}
	${Xt}
`,er=wt`
	fragment ExareUnvoluntaryReasonInfo on ExareUnvoluntaryReasonInfo {
		reason
		docs
	}
`,tr=wt`
	fragment ChangeTravellerDataInfo on ChangeTravellerDataInfo {
		travellers {
			...ChangeTravellerDataTravellerInfo
		}
		reasonsInfo {
			...ExareUnvoluntaryReasonInfo
		}
	}
	${Zt}
	${er}
`,rr=wt`
	fragment FlightStatusAirport on Airport {
		id
		name
		iata
		latitude
		longitude
		title
		city {
			name
		}
		country {
			name
		}
	}
`,nr=wt`
	fragment LocationGroup on LocationGroup {
		cities {
			airports {
				...FlightStatusAirport
			}
		}
	}
	${rr}
`,ir=wt`
	fragment FlightStatusResponse on FlightStatusInfo {
		id
		flightNumber
		status
		pathCompletion
		aircraft {
			id
			name
			icon
			iconRt
		}
		flightInfo {
			amenities {
				type
				description
				available
			}
		}
		airline {
			iata
			name
			icon
		}
		duration {
			days
			hours
			minutes
			seconds
		}
		departure {
			date
			time
			airport {
				...FlightStatusAirport
			}
		}
		arrival {
			date
			time
			airport {
				...FlightStatusAirport
			}
		}
	}
	${rr}
`,ar=wt`
	fragment Airport on Airport {
		id
		name
		title
		iata
		latitude
		longitude
		city {
			name
			images {
				panorama {
					url
				}
			}
		}
		country {
			id
			name
		}
		images {
			panorama {
				url
			}
		}
	}
`,or=wt`
	fragment ScheduleResultSegmentSearchParameter on ScheduleResultSegmentSearchParameter {
		departure {
			...Airport
		}
		arrival {
			...Airport
		}
	}
	${ar}
`,ur=wt`
	fragment FullFlightsParameters on ScheduleResultSearchParameters {
		segments {
			...ScheduleResultSegmentSearchParameter
		}
	}
	${or}
`,sr=wt`
	fragment Airline on IAirline {
		id
		iata
		name
		logo {
			url
		}
		icon
	}
`,cr=wt`
	fragment ScheduleResultPoint on ScheduleResultPoint {
		airport {
			...Airport
		}
		terminal
		time
	}
	${ar}
`,dr=wt`
	fragment Duration on Duration {
		days
		hours
		minutes
		seconds
	}
`,lr=wt`
	fragment SegmentStop on SegmentStop {
		airport {
			...Airport
		}
		duration {
			days
			hours
			minutes
			seconds
		}
	}
	${ar}
`,fr=wt`
	fragment FlightStaticInfo on FlightStaticInfo {
		statistics {
			title
			value
		}
		amenities {
			type
			description
			available
		}
		markers {
			charter
			eco
		}
	}
`,mr=wt`
	fragment AircraftInfoParameter on TitleValueParameter {
		title
		value
	}
`,pr=wt`
	fragment AircraftInfoCabin on CabinInfo {
		title
		image
		parameters {
			...AircraftInfoParameter
		}
	}
	${mr}
`,hr=wt`
	fragment ScheduleResultSegment on ScheduleResultSegment {
		id
		flightNumber
		operatingAirline {
			...Airline
		}
		marketingAirline {
			...Airline
		}
		departure {
			...ScheduleResultPoint
		}
		arrival {
			...ScheduleResultPoint
		}
		duration {
			...Duration
		}
		stops {
			...SegmentStop
		}
		datesData {
			date
		}
		flightInfo {
			...FlightStaticInfo
		}
		aircraft {
			id
			title
			name
			icon
			iconRt
			images
			scheme
			cabins {
				...AircraftInfoCabin
			}
			parameters {
				title
				value
			}
			description
		}
		flightProbability
		scheduleStartDate
		scheduleEndDate
		weekdays
		aircrafts {
			title
			icon
			images
			scheme
			cabins {
				...AircraftInfoCabin
			}
			description
			parameters {
				title
				value
				type
			}
			id
			name
		}
	}
	${sr}
	${cr}
	${dr}
	${lr}
	${fr}
	${pr}
`,gr=wt`
	fragment ScheduleFlightDirectionsLegs on ScheduleResultLeg {
		segments {
			segment {
				...ScheduleResultSegment
			}
			transferDuration {
				...Duration
			}
		}
		weekdays
	}
	${hr}
	${dr}
`,yr=wt`
	fragment FullFlightsSchedule on FullFlightsScheduleResponse {
		searchParameters {
			...FullFlightsParameters
		}
		flightDirections {
			legs {
				...ScheduleFlightDirectionsLegs
			}
		}
	}
	${ur}
	${gr}
`,vr=wt`
	fragment InfoMessages on InfoMessage {
		title
		image
		text
		type
		code
		positions
	}
`,Sr=wt`
	fragment Weather on WeatherInfo {
		type
		description
		temperature
		measurement
	}
`,Pr=wt`
	fragment FlightPoint on FlightPoint {
		date
		time
		terminal
		weather {
			...Weather
		}
		airport {
			...Airport
		}
	}
	${Sr}
	${ar}
`,Dr=wt`
	fragment Segment on FlightSegment {
		id
		flightNumber
		flightInfo {
			...FlightStaticInfo
		}
		messages {
			...InfoMessages
			...InfoMessages
		}
		operatingAirline {
			name
			iata
			icon
		}
		marketingAirline {
			name
			iata
			icon
		}
		aircraft {
			id
			name
			icon
			iconRt
		}
		duration {
			days
			hours
			minutes
		}
		departure {
			...FlightPoint
		}
		arrival {
			...FlightPoint
		}
		stops {
			...SegmentStop
		}
		status
		subStatus
		messages {
			...InfoMessages
		}
		lowestPriceClassSeatsLeft
	}
	${fr}
	${vr}
	${Pr}
	${lr}
`,Cr=wt`
	fragment SegmentWithTransfer on FlightSegmentWithTransferInformation {
		transferDuration {
			days
			hours
			minutes
		}
		segment {
			...Segment
		}
	}
	${Dr}
`,Fr=wt`
	fragment FareFamilyOption on AviaFareFamilyOption {
		type
		availability
		title
		description
		isKeyOption
		promo
		shortDescription
		value
		size
		iconUrl
	}
`,Ir=wt`
	fragment FareFamily on AviaFareFamily {
		id
		title
		description
		infoImage
		marker
		promo
		isRecommended
		category
		airline {
			name
			iata
			icon
			logo {
				fullUrl
			}
		}
		options {
			...FareFamilyOption
		}
	}
	${Fr}
`,Tr=wt`
	fragment PlainFlight on Flight {
		id
		canBePaidByMiles
		subsidized
		fares {
			id
			passengerFares {
				priceClasses {
					classCode
				}
			}
		}
	}
`,Or=wt`
	fragment FareFamilyPrice on AviaSegmentPrice {
		fareFamily {
			...FareFamily
		}
		prices {
			originalPrice {
				...Money
			}
			price {
				...Money
			}
			flight {
				...PlainFlight
			}
			priceInMiles
		}
		flights {
			...PlainFlight
		}
	}
	${Ir}
	${_t}
	${Tr}
`,Ar=wt`
	fragment ResultsLeg on AviaSearchResultLeg {
		segments {
			...SegmentWithTransfer
		}
		pricesForFareGroups {
			...FareFamilyPrice
		}
	}
	${Cr}
	${Or}
`,$r=wt`
	fragment FareGroupOption on AviaFareGroupOption {
		type
		payment
		title
		description
	}
`,Er=wt`
	fragment FareGroup on AviaFareGroup {
		id
		airline {
			iata
			name
		}
		name
		description
		options {
			...FareGroupOption
		}
		type
	}
	${$r}
`,Mr=wt`
	fragment SearchResultFlightDirections on SearchResultFlightDirection {
		legs {
			...ResultsLeg
		}
		fareGroups {
			...FareGroup
		}
	}
	${Ar}
	${Er}
`,Nr=wt`
	fragment ExarePriceDetails on ExarePriceDetailsGroup {
		elements {
			money {
				...Money
			}
			type
			passengerId
		}
		sum {
			...Money
		}
	}
	${_t}
`,Rr=wt`
	fragment ExareVariantPriceInfo on ExchangeVariantPriceInfo {
		basePrice {
			...Money
		}
		priceToPay {
			...Money
		}
		agencyChargesForExare {
			...Money
		}
		priceDetails {
			refunded {
				...ExarePriceDetails
			}
			retention {
				...ExarePriceDetails
			}
			paid {
				...ExarePriceDetails
			}
		}
		selectedFlightPrice {
			...Money
		}
		selectedFlightPriceWithAirlinePenalty {
			...Money
		}
		selectedFlightTotalPrice {
			...Money
		}
		exchangeAirlinePenalty {
			...Money
		}
		flightId
	}
	${_t}
	${Nr}
`,br=wt`
	fragment LocationCode on LocationCode {
		code
		supplier
	}
`,xr=wt`
	fragment LocationSuggestion on LocationInLocationGroup {
		iata
		name
		stopPointsCount
		match {
			type
			iata
			distance
			name
		}
		codes {
			...LocationCode
		}
	}
	${br}
`,kr=wt`
	fragment LocationSuggestionGroup on LocationGroup {
		type
		country {
			name
		}
		cities {
			...LocationSuggestion
		}
	}
	${xr}
`,Lr=wt`
	fragment ValidationRule on ValidationRule {
		...IValidationRule
		with {
			...WithParameter
		}
	}
	${Ht}
	${Yt}
`,wr=wt`
	fragment TravellerParameter on TravellerParameter {
		type
		name
		value
		validationRules {
			...ValidationRule
		}
	}
	${Lr}
`,Gr=wt`
	fragment TravellerParameterEditable on TravellerParameter {
		...TravellerParameter
		isEditable
	}
	${wr}
`,Qr=wt`
	fragment PassengerSelectedGdsServicesProduct on OrderAdditionalServiceGdsServiceProduct {
		id
		passengerId
		price {
			...Money
		}
		status
		emdNumber
	}
	${_t}
`,_r=wt`
	fragment SelectedSeat on TravellerSeat {
		row
		letter
		isConfirmed
		isChangeable
		onRequest
		segment {
			id
		}
		seat {
			rfisc
			number
			restrictions
			permissions
			letter
			isAvailable
			isAisle
			isExistent
			isSmoking
			isRecline
			isNearWindow
			isNearWindowWithoutWindow
			isFrontOfToilet
			isMoreSpaceForLegs
			price {
				...Money
			}
			seatService {
				id
				canBeAdded
				comfort
				serviceClass
				price {
					...Money
				}
			}
			seatServices {
				id
				canBeAdded
				comfort
				serviceClass
				price {
					...Money
				}
			}
		}
		product {
			...PassengerSelectedGdsServicesProduct
		}
		type
	}
	${_t}
	${Qr}
`,Br=wt`
	fragment SeatInfoBySegment on GdsServiceSeatInfoBySegment {
		segment {
			id
		}
		image
	}
`,zr=wt`
	fragment SeatService on OrderAdditionalServiceGdsServiceSeat {
		serviceImage: image
		serviceClass
		infoBySegments {
			...SeatInfoBySegment
		}
		comfort
		serviceClass
		showSeatDescription
		canBeAdded
		price {
			...Money
		}
		parameters {
			title
			value
		}
		description
	}
	${Br}
	${_t}
`,Ur=wt`
	fragment BaggageService on OrderAdditionalServiceGdsServiceBaggage {
		size
		baggageWeight: weight
		baggageType
	}
`,Vr=wt`
	fragment MealServices on OrderAdditionalServiceGdsServiceMeal {
		category
		mealWeight: weight
		allergens
		icon
		image
	}
`,qr=wt`
	fragment PriceFreeze on OrderAdditionalServiceGdsServicePriceFreeze {
		isPriceFreeze
		freezeUntil
	}
`,Wr=wt`
	fragment VipService on OrderAdditionalServiceGdsServiceVip {
		isPriceFreeze
		subType
	}
`,jr=wt`
	fragment GdsService on IGdsServiceInfo {
		id
		type
		name
		isPriceFreeze
		isFake
		description
		price {
			amount
			currency
		}
		allowedSegments
		allowedPassengers
		rfisc
		isFake
		canBeAdded
		gdsType
		isReplacedBy
		timelineStep
		... on OrderAdditionalServiceGdsServiceSeat {
			...SeatService
		}
		... on OrderAdditionalServiceGdsServiceBaggage {
			...BaggageService
		}
		... on OrderAdditionalServiceGdsServiceMeal {
			...MealServices
		}
		... on OrderAdditionalServiceGdsServicePriceFreeze {
			...PriceFreeze
		}
		... on OrderAdditionalServiceGdsServiceVip {
			...VipService
		}
	}
	${zr}
	${Ur}
	${Vr}
	${qr}
	${Wr}
`,Kr=wt`
	fragment IncludedGdsServices on TravellerSelectedServicesGdsServices {
		serviceId
		count
		segmentIds
		confirmedCount
		service {
			...GdsService
		}
	}
	${jr}
`,Hr=wt`
	fragment PassengerSelectedGdsServices on TravellerSelectedServicesGdsServices {
		serviceId
		count
		segmentIds
		confirmedCount
		products {
			...PassengerSelectedGdsServicesProduct
		}
	}
	${Qr}
`,Yr=wt`
	fragment PreselectedSeat on TravellerSeat {
		segment {
			id
		}
		seat {
			number
			row
			letter
			price {
				amount
				currency
			}
			rfisc
		}
		type
	}
`,Jr=wt`
	fragment SubsidyInfo on StaticSubsidyObject {
		id
		name
		description
		validation {
			type
			name
			value
			validationRules {
				...ValidationRule
			}
			isEditable
		}
	}
	${Lr}
`,Xr=wt`
	fragment TravellerDisability on TravellerDisability {
		id
		name
		notCombinedWithAny
	}
`,Zr=wt`
	fragment Passenger on AviaTraveller {
		id
		type
		supplierTravellerType
		values {
			...TravellerParameterEditable
		}
		services {
			seats {
				...SelectedSeat
			}
			brandIncludedServices {
				services {
					...IncludedGdsServices
				}
			}
			gdsServices {
				services {
					...PassengerSelectedGdsServices
				}
			}
		}
		preselectedServices {
			seats {
				...PreselectedSeat
			}
			gdsServices {
				services {
					...PassengerSelectedGdsServices
				}
			}
		}
		linkedTraveller {
			id
			type
			values {
				...TravellerParameter
			}
		}
		needOthsSsr
		subsidyInfo {
			subsidies {
				...SubsidyInfo
			}
		}
		fares {
			passengerFares {
				totalFare {
					...Money
				}
			}
		}
		availableDisabilities {
			...TravellerDisability
		}
		disabilities {
			...TravellerDisability
		}
		tickets {
			number
		}
		seatRestrictions
	}
	${Gr}
	${_r}
	${Kr}
	${Hr}
	${Yr}
	${wr}
	${Jr}
	${_t}
	${Xr}
`,en=wt`
	fragment RefundTraveller on AviaTraveller {
		...Passenger
		linkedTraveller {
			...Passenger
		}
	}
	${Zr}
`,tn=wt`
	fragment RefundPrices on ExarePriceInfo {
		agencyChargesForExare {
			...Money
		}
		priceToPay {
			...Money
		}
		basePrice {
			...Money
		}
	}
	${_t}
`,rn=wt`
	fragment RefundOrder on ExareRefundOrder {
		id
		isCompelled
		travellers {
			...RefundTraveller
		}
		refuseAllowed
		status
		createDate
		timelimit
		automaticMode
		userComment
		managerCalculationComment
		managerRejectComment
		reason
		loadedFiles {
			passengerId
			type
		}
		prices {
			...RefundPrices
		}
		warnings
	}
	${en}
	${tn}
`,nn=wt`
	fragment OrderWithLastRefund on AviaOrder {
		exareInfo {
			lastRefund {
				...RefundOrder
			}
		}
	}
	${rn}
`,an=wt`
	fragment NASProductFare on NASProductFare {
		id
		name
		prices {
			traveller {
				id
			}
			price {
				...Money
			}
		}
		totalPrice {
			...Money
		}
	}
	${_t}
`,on=wt`
	fragment NASProduct on NASProduct {
		id
		price {
			...Money
		}
		name
		type
		category
		segmentId
		images
		description
		direction
		maxDuration
		meetingPoint
		timelineStep
		terminalName
		notes
		facilities
		timelineStep
		terms {
			lang
			url
			html
		}
		additionalServices {
			id
			name
			description
			paymentUnit
			price {
				...Money
			}
		}
		fares {
			...NASProductFare
		}
		canBeAdded
	}
	${_t}
	${an}
`,un=wt`
	fragment NASSelectedProduct on NASSelectedProduct {
		product {
			id
			category
		}
		additionalService {
			id
			price {
				...Money
			}
		}
		travellers {
			id
		}
		fare {
			id
			name
			prices {
				traveller {
					id
				}
				price {
					...Money
				}
			}
			totalPrice {
				...Money
			}
		}
		status
		orders {
			travellers {
				id
			}
			status
			isRefundable
		}
	}
	${_t}
`,sn=wt`
	fragment RefundInfo on ExareRefundInfo {
		prices @include(if: $includePrices) {
			...RefundPrices
		}
		confirmationDocsAreRequired
		seatReleaseMode
		unvoluntaryReasonsInfo {
			docs
			reason
		}
		additionalServices {
			nas {
				services {
					...NASProduct
				}
				selectedServices {
					...NASSelectedProduct
				}
			}
		}
	}
	${tn}
	${on}
	${un}
`,cn=wt`
	fragment FlightDirection on SearchResultFlightDirection {
		legs {
			...ResultsLeg
		}
	}
	${Ar}
`,dn=wt`
	fragment AviaPassengerFare on AviaPassengerFare {
		count
		passengerType
		totalTaxes {
			...Money
		}
		baseFare {
			...Money
		}
		totalFare {
			...Money
		}
	}
	${_t}
`,ln=wt`
	fragment ResultFare on IFlightFare {
		id
		passengerFares {
			...AviaPassengerFare
		}
	}
	${dn}
`,fn=wt`
	fragment PaymentMethod on IPaymentMethod {
		id
		name
		description
		transactionId
		paymentProvider
		paymentCharge {
			amount
			currency
		}
		totalPrice {
			amount
			currency
		}
		timelimitInSeconds
		gatewayType
	}
`,mn=wt`
	fragment CashMethod on CashOneclickpayGatewayInfo {
		...PaymentMethod
		secureCodeTimeLimitInSeconds
	}
	${fn}
`,pn=wt`
	fragment CardPaymentMethod on CardGatewayInfo {
		...PaymentMethod
	}
	${fn}
`,hn=wt`
	fragment TravellerVisaParameter on TravellerVisaParameter {
		name
		type
		value
		validationRules {
			...ValidationRule
		}
	}
	${Lr}
`,gn=wt`
	fragment TravellerSelectedServices on TravellerSelectedServicesResponse {
		seats {
			...SelectedSeat
		}
		gdsServices {
			services {
				...PassengerSelectedGdsServices
			}
		}
		brandIncludedServices {
			services {
				...IncludedGdsServices
			}
		}
	}
	${_r}
	${Hr}
	${Kr}
`,yn=wt`
	fragment TravellerPreselectedServices on TravellerSelectedServicesResponse {
		seats {
			...PreselectedSeat
		}
		gdsServices {
			services {
				...PassengerSelectedGdsServices
			}
		}
	}
	${Yr}
	${Hr}
`,vn=wt`
	fragment CheckinPassenger on CheckinTraveller {
		id
		type
		supplierTravellerType
		canBeDeleted
		isConfirmed
		visaRequired
		visaValues {
			...TravellerVisaParameter
		}
		tickets {
			number
		}
		linkedTraveller {
			id
			type
			values {
				name
				type
				value
				validationRules {
					...ValidationRule
				}
			}
		}
		values {
			type
			value
			isEditable
			name
			validationRules {
				hidden
				hint
				label
				maxDate
				maxLength
				minDate
				placeholder
				regExp {
					error
					pattern
				}
				required
				with {
					name
					type
					value
				}
				options {
					value
					label
				}
			}
		}
		services {
			...TravellerSelectedServices
		}
		preselectedServices {
			...TravellerPreselectedServices
		}
		linkedTraveller {
			id
		}
		seatRestrictions
	}
	${hn}
	${Lr}
	${gn}
	${yn}
`,Sn=wt`
	fragment CheckinTravellerFareFamily on CheckinTravellerFareFamily {
		fareFamily {
			...FareFamily
		}
		travellers {
			id
		}
	}
	${Ir}
`,Pn=wt`
	fragment CheckinInfo on CheckinFlightSegmentInfo {
		checkInSubStatus
		webOpenTime
		webCloseTime
		airportOpenTime
		airportCloseTime
		boardingOpenTime
		boardingCloseTime
		checkinAvailable
		cancelAvailable
		airportHasDcs
		timeBeforeClosingCheckin
		checkInStatus
		hasBoardingPasses
		travellersData {
			travellers {
				subStatus
				traveller {
					id
				}
			}
		}
	}
`,Dn=wt`
	fragment CheckinSegment on CheckinFlightSegment {
		id
		flightNumber
		operatingAirline {
			iata
		}
		marketingAirline {
			iata
		}
		duration {
			...Duration
		}
		aircraft {
			name
			icon
		}
		stops {
			...SegmentStop
		}
		departure {
			date
			time
			terminal
			airport {
				...Airport
			}
			weather {
				...Weather
			}
		}
		arrival {
			date
			time
			terminal
			weather {
				...Weather
			}
			airport {
				...Airport
			}
		}
		fareFamilies {
			...CheckinTravellerFareFamily
		}
		checkinInfo {
			...CheckinInfo
		}
	}
	${dr}
	${lr}
	${ar}
	${Sr}
	${Sn}
	${Pn}
`,Cn=wt`
	fragment Baggage on OrderAdditionalServiceGdsServiceBaggage {
		id
		type
		name
		description
		price {
			...Money
		}
		allowedSegments
		allowedPassengers
		rfisc
		baggageType
		canBeAdded
		weight
		size
	}
	${_t}
`,Fn=wt`
	fragment InsuranceProgramExtraParam on InsuranceProgramExtraParam {
		key
		value
	}
`,In=wt`
	fragment InsuranceProgram on InsuranceProgram {
		description
		name
		code
		options {
			name
			included
		}
		important
		canBeAdded
		urlToOffer
		price {
			...Money
		}
		totalPrice {
			...Money
		}
		extraParams {
			...InsuranceProgramExtraParam
		}
		type
	}
	${_t}
	${Fn}
`,Tn=wt`
	fragment SelectedInsurance on SelectedInsurance {
		insuranceProgram {
			...InsuranceProgram
		}
		passengerName
		policyNumber
		policyUrl
		passengerPrice {
			...Money
		}
	}
	${In}
	${_t}
`,On=wt`
	fragment InsuranceProgramGroup on InsuranceProgramGroup {
		groupValue
		insurancePrograms {
			code
		}
	}
`,An=wt`
	fragment Insurance on Insurance {
		separateStep
		travellerExtraValues {
			traveller {
				id
			}
			extraValues {
				type
				name
				value
				validationRules {
					...ValidationRule
				}
			}
			needKzIinDocument
		}
		insurancePrograms {
			...InsuranceProgram
		}
		selectedInsurances {
			...SelectedInsurance
		}
		insuranceProgramGroups {
			...InsuranceProgramGroup
		}
	}
	${Lr}
	${In}
	${Tn}
	${On}
`,$n=wt`
	fragment AeroexpressStation on AeroexpressStation {
		direction
		name
	}
`,En=wt`
	fragment AeroexpressFare on AeroexpressFare {
		class
		passengersCount
		passengers {
			id
			type
		}
		price {
			...Money
		}
		totalPrice {
			...Money
		}
		date
	}
	${_t}
`,Mn=wt`
	fragment Trip on ITrip {
		id
		price {
			...Money
		}
		departureDate
		fromStation {
			...AeroexpressStation
		}
		toStation {
			...AeroexpressStation
		}
		segments {
			id
			departure {
				...FlightPoint
			}
			arrival {
				...FlightPoint
			}
		}
		fares {
			...AeroexpressFare
		}
		class
		segments {
			id
		}
	}
	${_t}
	${$n}
	${Pr}
	${En}
`,Nn=wt`
	fragment AeroExpressTicket on AeroexpessTicket {
		maxTickets
		price {
			...Money
		}
		maxDays
		imageUrl
	}
	${_t}
`,Rn=wt`
	fragment SelectedTrips on AeroexpressSelectedTrip {
		...Trip
		tickets {
			...AeroExpressTicket
		}
	}
	${Mn}
	${Nn}
`,bn=wt`
	fragment Aeroexpress on TransferService {
		aeroexpress {
			trips {
				...Trip
			}
			selectedTrips {
				...Trip
				...SelectedTrips
			}
		}
	}
	${Mn}
	${Rn}
`,xn=wt`
	fragment WidgetTravellers on AviaTraveller {
		id
		values {
			type
			name
			value
		}
	}
`,kn=wt`
	fragment WidgetParameters on WidgetInitializeParameters {
		cartId
		orderId
		countryIso2
		countryGeonamesId
		arrDate
		depDate
		locale
		currency
		userId
		travellers {
			...WidgetTravellers
		}
		segmentId
	}
	${xn}
`,Ln=wt`
	fragment WidgetAdditionalService on WidgetAdditionalService {
		widgetType
		state
		authToken
		endpoint
		price {
			...Money
		}
		initializeParameters {
			...WidgetParameters
		}
	}
	${_t}
	${kn}
`,wn=wt`
	fragment AdditionalServices on OrderAdditionalServices {
		gdsServices {
			services {
				...GdsService
				... on OrderAdditionalServiceGdsServiceBaggage {
					...Baggage
				}
			}
			type
			servicesRestrictionsByType {
				restrictionType
				value
				maxCount
				gdsType
				maxCountForTravellerOnSegment
			}
		}
		insurances {
			...Insurance
		}
		transfer {
			...Aeroexpress
		}
		nas {
			services {
				...NASProduct
			}
			selectedServices {
				...NASSelectedProduct
			}
		}
		everyTravel {
			...WidgetAdditionalService
		}
	}
	${jr}
	${Cn}
	${An}
	${bn}
	${on}
	${un}
	${Ln}
`,Gn=wt`
	fragment RowSeat on SeatMapSegmentDeckRowSeat {
		rfisc
		isNearPartitionWall
		isComfort
		number
		restrictions
		permissions
		letter
		row
		isAvailable
		isAisle
		isExistent
		isSmoking
		isRecline
		isNearWindow
		isNearWindowWithoutWindow
		isFrontOfToilet
		isMoreSpaceForLegs
		price {
			...Money
		}
		seatService {
			id
			canBeAdded
			comfort
			serviceClass
			price {
				...Money
			}
		}
		seatServices {
			id
			allowedPassengers
			canBeAdded
			comfort
			serviceClass
			price {
				...Money
			}
		}
	}
	${_t}
`,Qn=wt`
	fragment FlightSeatMapRow on SeatMapSegmentDeckRow {
		number
		cabinCode
		seats {
			...RowSeat
		}
		wing
		exitRow
	}
	${Gn}
`,_n=wt`
	fragment FlightSeatMapSegment on SeatMapSegment {
		isSeatsAvailableInCheckinOnly
		sunSide
		segmentsInfo {
			id
			operatingAirline {
				icon
				iata
			}
			duration {
				days
				hours
				minutes
				seconds
			}
			departure {
				airport {
					id
					city {
						name
					}
				}
			}
			arrival {
				airport {
					id
					city {
						name
					}
				}
			}
			aircraft {
				id
				name
				icon
				iconRt
			}
		}
		isAnySeatExistsAndFree
		availableSeatsCount
		decks {
			isUpper
			rows {
				...FlightSeatMapRow
			}
		}
	}
	${Qn}
`,Bn=wt`
	fragment FlightSeatMapService on IGdsServiceInfo {
		id
		name
		price {
			...Money
		}
		rfisc
		type
		canBeAdded
		allowedPassengers
		allowedSegments
		... on OrderAdditionalServiceGdsServiceSeat {
			...SeatService
		}
	}
	${_t}
	${zr}
`,zn=wt`
	fragment FlightSeatMap on SeatMap {
		segments {
			...FlightSeatMapSegment
		}
		additionalServices {
			gdsServices {
				services {
					...FlightSeatMapService
				}
				type
			}
		}
	}
	${_n}
	${Bn}
`,Un=wt`
	fragment PriceBreakdownDetails on PriceBreakdown {
		type
		price {
			amount
			currency
		}
		parts {
			type
			price {
				amount
				currency
			}
			parts {
				type
				price {
					amount
					currency
				}
				parts {
					type
					price {
						amount
						currency
					}
					parts {
						type
						price {
							amount
							currency
						}
						parts {
							type
							price {
								amount
								currency
							}
						}
					}
				}
			}
		}
	}
`,Vn=wt`
	fragment PriceParts on PriceParts {
		airticket {
			...Money
		}
		charge {
			...Money
		}
		aeroexpress {
			...Money
		}
		insurance {
			...Money
		}
		seats {
			...Money
		}
		meals {
			...Money
		}
		baggage {
			...Money
		}
		businessLounge {
			...Money
		}
		total {
			...Money
		}
		vip {
			...Money
		}
	}
	${_t}
`,qn=wt`
	fragment CheckinOrder on CheckinOrder {
		id
		status
		paymentIsRequired
		isBlockedForPayment
		customer {
			... on Customer {
				contactInfoIsEmpty
				values {
					...TravellerParameterEditable
				}
			}
		}
		travellers {
			...CheckinPassenger
		}
		segments {
			...CheckinSegment
		}
		additionalServices {
			...AdditionalServices
		}
		seatMap {
			...FlightSeatMap
		}
		priceBreakdown {
			...PriceBreakdownDetails
		}
		priceToPay {
			...PriceParts
		}
		price {
			...PriceParts
		}
		paymentInfo {
			transactionsInfo {
				id
			}
		}
		allTravellersHaveSeatsWithoutServices
		allTravellersHavePreseating
		messages {
			...InfoMessages
		}
		warnings {
			...InfoMessages
		}
		isTravellersDataFilled
		isSkipSeatSelectionAllowed
	}
	${Gr}
	${vn}
	${Dn}
	${wn}
	${zn}
	${Un}
	${Vn}
	${vr}
`,Wn=wt`
	fragment Customer on Customer {
		id
		type
		contactInfoIsEmpty
		values {
			...TravellerParameterEditable
		}
	}
	${Gr}
`,jn=wt`
	fragment ExareOrder on IExareOrder {
		id
		travellers {
			...Passenger
		}
		createDate
		additionalOrderIds
		refuseAllowed
		status
		timelimit
		userComment
		automaticMode
		managerCalculationComment
		managerRejectComment
		warnings
	}
	${Zr}
`,Kn=wt`
	fragment ExistentEmailByFfpData on ExistentEmailByFfpData {
		email
		sameAccount
	}
`,Hn=wt`
	fragment PassengerFare on AviaPassengerFare {
		priceClasses {
			classCode
			seatsLeft
		}
	}
`,Yn=wt`
	fragment FlightsScheduleItem on FlightsScheduleItem {
		date
	}
`,Jn=wt`
	fragment GatewayPayment on GatewayPaymentCode {
		...PaymentMethod
		paymentCode @include(if: $withKaspi)
		paymentCode @include(if: $withQiwi)
	}
	${fn}
`,Xn=wt`
	fragment GooglePayMethod on GooglePayGatewayInfo {
		...PaymentMethod
		token @include(if: $withGpay)
	}
	${fn}
`,Zn=wt`
	fragment InvoiceMethod on InvoiceOneclickpayGatewayInfo {
		...PaymentMethod
		secureCodeTimeLimitInSeconds
	}
	${fn}
`,ei=wt`
	fragment OrderPromoCodeInfo on OrderPromoCodeInfo {
		success
		travellers {
			id
			values {
				name
				value
			}
			promoCodeInfo {
				code
				initialPrice {
					...Money
				}
				discount {
					...Money
				}
				resultPrice {
					...Money
				}
				rejectMessage
			}
		}
		initialOrderPrice {
			...Money
		}
	}
	${_t}
`,ti=wt`
	fragment PaximizerSectionMessage on PaximizerSectionMessage {
		text
		datetime
		title
	}
`,ri=wt`
	fragment PaximizerCommunicationSection on PaximizerCommunicationSection {
		id
		title
		unreadMessagesCount
		lastMessage {
			...PaximizerSectionMessage
		}
	}
	${ti}
`,ni=wt`
	fragment PaximizerTeaserClient on PaximizerTeaserClientProfile {
		firstName
		lastName
	}
`,ii=wt`
	fragment PaximazerTeaserOrderInfo on PaximizerTeaserOrderNotification {
		id
		title
		locator
		routeType
		text
		read
		date
		departureAirport {
			iata
		}
		departureDate
		arrivalAirport {
			iata
		}
		arrivalDate
		orderId
		travellers {
			...PaximizerTeaserClient
		}
	}
	${ni}
`,ai=wt`
	fragment PaximizerTeaserMyAppealNotification on PaximizerTeaserMyAppealNotification {
		id
		title
		status
		firstMessage
		createdAt
		updatedAt
		unreadMessageCount
		read
	}
`,oi=wt`
	fragment PaximizerTeaserPromoCodeNotification on PaximizerTeaserPromoCodeNotification {
		id
		title
		read
		code
		isPersonal
		isReusable
		endDate
		usedAt
		locator
	}
`,ui=wt`
	fragment PaximizerTeaserPromotionNotification on PaximizerTeaserPromotionNotification {
		id
		title
		read
		date
		text
		image
	}
`,si=wt`
	fragment PaximizerCommunicationNotificationContent on PaximizerCommunicationNotificationContent {
		id
		date
		read
		title
		body
	}
`,ci=wt`
	fragment PaximizerCommunicationOrderNotificationContent on PaximizerCommunicationOrderNotificationContent {
		id
		date
		read
		title
		body
		orderId
		body
		read
		id
	}
`,di=wt`
	fragment SearchParametersAirport on Airport {
		name
		iata
		city {
			name
		}
	}
`,li=wt`
	fragment SearchParameters on SearchParametersResponse {
		promotionCode
		passengers {
			passengerType
			extendedPassengerType
			count
		}
		segments {
			arrival {
				...SearchParametersAirport
			}
			departure {
				...SearchParametersAirport
			}
			date
		}
		ffpMode
		currency
	}
	${di}
`,fi=wt`
	fragment ProfileDocument on TravellerDocument {
		number
		expiryDate
		type
		citizenship
		firstName
		lastName
		middleName
		values {
			...TravellerParameter
		}
	}
	${wr}
`,mi=wt`
	fragment TravellerProfile on TravellerProfile {
		id
		canBeDeleted
		documents {
			...ProfileDocument
		}
		loyaltyCards {
			airline {
				id
				iata
				name
				logo {
					url
					fullUrl
				}
			}
			number
			values {
				...TravellerParameter
			}
		}
		values {
			...TravellerParameter
		}
	}
	${fi}
	${wr}
`,pi=wt`
	fragment Profile on IProfile {
		documents {
			...ProfileDocument
		}
		loyaltyCards {
			airline {
				id
				iata
				name
				logo {
					url
					fullUrl
				}
			}
			number
			values {
				...TravellerParameter
			}
		}
	}
	${fi}
	${wr}
`,hi=wt`
	fragment User on UserProfile {
		...Profile
		id
		firstName
		lastName
		middleName
		latinFirstName
		latinLastName
		latinMiddleName
		birthDate
		gender
		citizenship
		phone
		email
		values {
			...TravellerParameter
		}
	}
	${pi}
	${wr}
`,gi=wt`
	fragment Flight on OrderFlight {
		id
		searchId
		segments {
			...SegmentWithTransfer
		}
		segmentGroups {
			groupId
			segments {
				...Segment
			}
			priceInMiles
			price {
				amount
				currency
			}
			fareFamily {
				...FareFamily
			}
			fareGroup {
				...FareGroup
			}
		}
		seatMap {
			...FlightSeatMap
		}
		fares {
			passengerFares {
				...AviaPassengerFare
			}
		}
	}
	${Cr}
	${Dr}
	${Ir}
	${Er}
	${zn}
	${dn}
`,yi=wt`
	fragment ActializationResults on OrderActualizationResult {
		status
		priceChangeDelta {
			amount
			currency
		}
		oldPrice {
			amount
			currency
		}
		newPrice {
			amount
			currency
		}
	}
`,vi=wt`
	fragment GdsServices on OrderAdditionalServiceGdsService {
		type
		services {
			...GdsService
		}
		servicesRestrictionsByType {
			restrictionType
			value
			maxCount
			gdsType
			maxCountForTravellerOnSegment
		}
	}
	${jr}
`,Si=wt`
	fragment OrderAdditionalServices on OrderAdditionalServices {
		gdsServices {
			...GdsServices
		}
		insurances {
			...Insurance
		}
		transfer {
			...Aeroexpress
		}
		nas {
			services {
				...NASProduct
			}
			selectedServices {
				...NASSelectedProduct
			}
		}
		everyTravel {
			...WidgetAdditionalService
		}
	}
	${vi}
	${An}
	${bn}
	${on}
	${un}
	${Ln}
`,Pi=wt`
	fragment OrderPrice on PriceParts {
		airticket {
			...Money
		}
		charge {
			...Money
		}
		aeroexpress {
			...Money
		}
		insurance {
			...Money
		}
		baggage {
			...Money
		}
		meals {
			...Money
		}
		seats {
			...Money
		}
		total {
			...Money
		}
		businessLounge {
			...Money
		}
		vip {
			...Money
		}
		nas {
			...Money
		}
		everyTravel {
			...Money
		}
		totalInMiles
	}
	${_t}
`,Di=wt`
	fragment TravellerCardFfpInfo on TravellerCardFfpInfo {
		bonusForFlight
		cardNumber
	}
`,Ci=wt`
	fragment FfpInfo on OrderFfpInfo {
		bonusForFlight
		ffpSupported
		priceForFlightInMiles
		skipPayment
		bonusByCard {
			...TravellerCardFfpInfo
		}
	}
	${Di}
`,Fi=wt`
	fragment ExchangeOrder on ExareExchangeOrder {
		id
		travellers {
			id
			type
			values {
				type
				name
				value
			}
		}
		createDate
		additionalOrderIds
		refuseAllowed
		status
		timelimit
		userComment
		automaticMode
		prices {
			basePrice {
				...Money
			}
			priceToPay {
				...Money
			}
			agencyChargesForExare {
				...Money
			}
			exchangeAirlinePenalty {
				...Money
			}
		}
		managerCalculationComment
		managerRejectComment
		flight {
			id
			segments {
				...SegmentWithTransfer
			}
			segmentGroups {
				groupId
				segments {
					...Segment
				}
				price {
					amount
					currency
				}
				fareFamily {
					...FareFamily
				}
				fareGroup {
					id
					name
					description
				}
			}
			fares {
				passengerFares {
					totalFare {
						...Money
					}
					equiveFare {
						...Money
					}
					baseFare {
						...Money
					}
					totalTaxes {
						...Money
					}
					count
					passengerType
					taxes {
						code
						price {
							...Money
						}
					}
				}
			}
		}
		isCompelled
		warnings
	}
	${_t}
	${Cr}
	${Dr}
	${Ir}
`,Ii=wt`
	fragment ChangeTravellerDataTravellerAvailability on ChangeTravellerDataTravellerAvailability {
		id
		available
		autoMode
	}
`,Ti=wt`
	fragment ChangeTravellerDataOrder on ChangeTravellerDataOrder {
		id
		createDate
		status
		timelimit
		userComment
		automaticMode
		managerCalculationComment
		managerRejectComment
		refuseAllowed
		isCompelled
		warnings
		loadedFiles {
			passengerId
			type
		}
		travellers {
			...RefundTraveller
		}
		prices {
			...RefundPrices
		}
	}
	${en}
	${tn}
`,Oi=wt`
	fragment ExareInfo on ExareInfo {
		exchangeAvailability
		exchangeAutoMode
		refundAvailability
		refundAutoMode
		lastRefund {
			...RefundOrder
		}
		lastExchange {
			...ExchangeOrder
		}
		childRefundWithoutAdultAllowed
		changeTravellerDataAvailability {
			...ChangeTravellerDataTravellerAvailability
		}
		lastChangeTravellerDataOrder {
			...ChangeTravellerDataOrder
		}
		nasRefundAllowed
		isExchangeVariantsAvailable
		isGetRefundInfoAvailable
	}
	${rn}
	${Fi}
	${Ii}
	${Ti}
`,Ai=wt`
	fragment CheckoutOrder on AviaOrder {
		id
		timeoutToReCheckAvailability
		isPriceFreezeProductSelected
		isTravellersDataFilled
		status
		paymentStatus
		warnings
		isArchived
		messages {
			...InfoMessages
		}
		locator
		accessCode
		timelimit
		timelimitInSeconds
		timeoutToReCheckAvailability
		canAddServices
		isBlockedForPayment
		canRemoveServices
		servicesFallbackURL
		redirectFromMetasearch
		showServicesBeforeBooking
		hasSubsidizedFares
		hideItFares
		flight {
			...Flight
		}
		customer {
			id
			type
			contactInfoIsEmpty
			subscribed
			showSubscribeCheckbox
			values {
				name
				value
				type
				validationRules {
					...ValidationRule
				}
				isEditable
			}
		}
		travellers {
			...Passenger
		}
		actualizationResult {
			...ActializationResults
		}
		fareGroups {
			...FareGroup
		}
		additionalServices {
			...OrderAdditionalServices
		}
		priceBreakdown {
			...PriceBreakdownDetails
		}
		price {
			...OrderPrice
		}
		priceToPay {
			...OrderPrice
		}
		paymentInfo {
			transactionsInfo {
				id
			}
		}
		ffpInfo {
			...FfpInfo
		}
		exareInfo {
			...ExareInfo
		}
		splittedOrdersIds
		parentOrderId
		ssrData {
			id
			ssrCode
			travellerIds
			segmentIds
			ssrText
			status
			supplierStatusCode
		}
	}
	${vr}
	${gi}
	${Lr}
	${Zr}
	${yi}
	${Er}
	${Si}
	${Un}
	${Pi}
	${Ci}
	${Oi}
`,$i=wt`
	fragment AiPurchasePrediction on AIPurchasePrediction {
		probability
		travellerId
	}
`,Ei=wt`
	fragment GdsServicesWithPurchasePredictions on IGdsServiceInfo {
		...GdsService
		aiPurchasePrediction {
			...AiPurchasePrediction
		}
	}
	${jr}
	${$i}
`,Mi=wt`
	fragment ServicesWithPurchasePrediction on OrderAdditionalServiceGdsService {
		services {
			...GdsServicesWithPurchasePredictions
		}
	}
	${Ei}
`,Ni=wt`
	fragment InsuranceProgramWithPurchasePrediction on Insurance {
		insurancePrograms {
			...InsuranceProgram
			aiPurchasePrediction {
				...AiPurchasePrediction
			}
		}
	}
	${In}
	${$i}
`,Ri=wt`
	fragment OrderAdditionalServicesWithPrediction on AviaOrder {
		additionalServices {
			gdsServices {
				...ServicesWithPurchasePrediction
			}
			insurances {
				...InsuranceProgramWithPurchasePrediction
			}
		}
	}
	${Mi}
	${Ni}
`,bi=wt`
	query GetAccountInfo($skipOrdersList: Boolean = false) {
		CurrentUser {
			isFfpAuthorizationNeeded
			authMethods {
				...AuthMethod
			}
			userProfile {
				...User
			}
			ordersList @skip(if: $skipOrdersList) {
				...AccountOrdersList
			}
			userFfpInfo {
				...UserFfpInfo
			}
		}
	}
	${Vt}
	${hi}
	${Bt}
	${Ut}
`;function xi(e){return Gt.useQuery(bi,e)}function ki(e){return Gt.useLazyQuery(bi,e)}const Li=wt`
	query GetTravellers {
		CurrentUser {
			travellerProfiles {
				...TravellerProfile
			}
			userProfile {
				...User
			}
		}
	}
	${mi}
	${hi}
`;function wi(e){return Gt.useQuery(Li,e)}function Gi(e){return Gt.useLazyQuery(Li,e)}const Qi=wt`
	mutation SaveMethod($params: SendSecureCodeParameters!) {
		SaveAuthMethod(parameters: $params) {
			result
			message
		}
	}
`;function _i(e){return Gt.useMutation(Qi,e)}const Bi=wt`
	mutation ConfirmMethod($params: AuthCredentials!) {
		ConfirmAuthMethod(parameters: $params) {
			result
			message
		}
	}
`;function zi(e){return Gt.useMutation(Bi,e)}const Ui=wt`
	mutation RemoveAuthMethod($params: ID) {
		DeleteAuthMethod(id: $params) {
			result
			message
		}
	}
`;function Vi(e){return Gt.useMutation(Ui,e)}const qi=wt`
	mutation RemoveAccount {
		RemoveAccount {
			result
			message
		}
	}
`;function Wi(e){return Gt.useMutation(qi,e)}const ji=wt`
	mutation SetUserSettings($params: [SaveSettingsParameters]) {
		SaveSettings(parameters: $params)
	}
`;function Ki(e){return Gt.useMutation(ji,e)}const Hi=wt`
	query GetUserSettings {
		UserSettings(keys: ["TermOfUse", "Subscribe"]) {
			value
			name
		}
	}
`;function Yi(e){return Gt.useQuery(Hi,e)}function Ji(e){return Gt.useLazyQuery(Hi,e)}const Xi=wt`
	query AccountExistence($params: SendSecureCodeParameters!) {
		AccountExistence(parameters: $params) {
			message
			result
		}
	}
`;function Zi(e){return Gt.useQuery(Xi,e)}function ea(e){return Gt.useLazyQuery(Xi,e)}const ta=wt`
	mutation FfpAccountLogout {
		FfpAccountLogout {
			result
			message
		}
	}
`;function ra(e){return Gt.useMutation(ta,e)}const na=wt`
	query FfpAccountHistory {
		FfpAccountHistory {
			recordId
			description
			milesInc
			milesDec
			statVol
			onTimeUTC
			miles
			flightNum
			flightDate
			flightClass
			promoMiles
			accountId
			clientId
		}
	}
`;function ia(e){return Gt.useQuery(na,e)}function aa(e){return Gt.useLazyQuery(na,e)}const oa=wt`
	query GetUserProfile {
		CurrentUser {
			userProfile {
				...UserProfileInfo
			}
			userFfpInfo {
				...UserProfileFfpInfo
			}
		}
	}
	${Wt}
	${jt}
`;function ua(e){return Gt.useQuery(oa,e)}function sa(e){return Gt.useLazyQuery(oa,e)}const ca=wt`
	query GetOrdersListPaginated($pagination: PaginationArguments, $selectionParams: GetOrderParameters) {
		AviaOrdersListPaginated(pagination: $pagination, selectionParams: $selectionParams) {
			edges {
				... on AviaOrderPaginationEdge {
					node {
						...AccountOrdersList
					}
				}
				cursor
			}
			pageInfo {
				pageNum
				totalPages
			}
		}
	}
	${Bt}
`;function da(e){return Gt.useQuery(ca,e)}function la(e){return Gt.useLazyQuery(ca,e)}const fa=wt`
	mutation DeleteOrder($params: ID!) {
		DeleteOrder(orderId: $params) {
			result
			message
		}
	}
`;function ma(e){return Gt.useMutation(fa,e)}const pa=wt`
	query ExistentEmailByFfp($login: String!, $password: String!) {
		ExistentEmailByFfp(login: $login, password: $password) {
			...ExistentEmailByFfpData
		}
	}
	${Kn}
`;function ha(e){return Gt.useQuery(pa,e)}function ga(e){return Gt.useLazyQuery(pa,e)}const ya=wt`
	query AdditionalServices($id: ID) {
		AdditionalServices(orderId: $id) {
			...AdditionalServices
		}
	}
	${wn}
`;function va(e){return Gt.useQuery(ya,e)}function Sa(e){return Gt.useLazyQuery(ya,e)}const Pa=wt`
	query AircraftInfo($id: String!, $operatingAirlineIata: String) {
		AircraftInfo(id: $id, operatingAirlineIata: $operatingAirlineIata) {
			title
			images
			scheme
			cabins {
				...AircraftInfoCabin
			}
			description
			parameters {
				title
				value
				type
			}
		}
	}
	${pr}
`;function Da(e){return Gt.useQuery(Pa,e)}function Ca(e){return Gt.useLazyQuery(Pa,e)}const Fa=wt`
	mutation BookOrder($params: BookOrderParameters) {
		BookOrder(parameters: $params) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Ia(e){return Gt.useMutation(Fa,e)}const Ta=wt`
	mutation CancelOrder($id: ID) {
		CancelOrder(id: $id) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Oa(e){return Gt.useMutation(Ta,e)}const Aa=wt`
	query ChangeTravelerDataInfo($parameters: ChangeTravellerDataInfoParams!) {
		ChangeTravellerDataInfo(parameters: $parameters) {
			...ChangeTravellerDataInfo
		}
	}
	${tr}
`;function $a(e){return Gt.useQuery(Aa,e)}function Ea(e){return Gt.useLazyQuery(Aa,e)}const Ma=wt`
	query ChangeTravellerDataPrice($parameters: GetChangeTravellerDataPriceParams!) {
		ChangeTravellerDataPrice(parameters: $parameters) {
			...RefundPrices
		}
	}
	${tn}
`;function Na(e){return Gt.useQuery(Ma,e)}function Ra(e){return Gt.useLazyQuery(Ma,e)}const ba=wt`
	mutation CheckinAddTraveller($params: CheckinAddTravellerParameters!) {
		CheckinAddTraveller(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function xa(e){return Gt.useMutation(ba,e)}const ka=wt`
	mutation CheckinCancel($params: CheckinCancelParameters!) {
		CheckinCancel(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function La(e){return Gt.useMutation(ka,e)}const wa=wt`
	mutation CheckinComplete($id: ID!) {
		CheckinComplete(id: $id) {
			...CheckinOrder
		}
	}
	${qn}
`;function Ga(e){return Gt.useMutation(wa,e)}const Qa=wt`
	mutation CheckinCreateOrder($params: CheckinOrderCreateParameters!) {
		CheckinCreateOrder(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function _a(e){return Gt.useMutation(Qa,e)}const Ba=wt`
	query CheckinDocuments($params: CheckinDocumentParameters!) {
		CheckinDocuments(parameters: $params) {
			content
			fileExtension
		}
	}
`;function za(e){return Gt.useQuery(Ba,e)}function Ua(e){return Gt.useLazyQuery(Ba,e)}const Va=wt`
	query CheckinInfo($params: CheckinInfoParameters!) {
		CheckinInfo(parameters: $params) {
			isAvailable
		}
	}
`;function qa(e){return Gt.useQuery(Va,e)}function Wa(e){return Gt.useLazyQuery(Va,e)}const ja=wt`
	mutation CheckinLoadServices($id: ID!) {
		CheckinLoadServices(id: $id) {
			...CheckinOrder
		}
	}
	${qn}
`;function Ka(e){return Gt.useMutation(ja,e)}const Ha=wt`
	mutation CheckinRemoveTraveller($params: CheckinRemoveTravellerParameters!) {
		CheckinRemoveTraveller(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function Ya(e){return Gt.useMutation(Ha,e)}const Ja=wt`
	query CheckinRules($id: ID!) {
		CheckinRules(orderId: $id)
	}
`;function Xa(e){return Gt.useQuery(Ja,e)}function Za(e){return Gt.useLazyQuery(Ja,e)}const eo=wt`
	mutation CheckinSaveOrderServices($params: OrderSelectedServices!) {
		CheckinSaveOrderServices(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function to(e){return Gt.useMutation(eo,e)}const ro=wt`
	mutation CheckinSendDocument($params: CheckinSendDocumentParameters!) {
		CheckinSendDocument(parameters: $params)
	}
`;function no(e){return Gt.useMutation(ro,e)}const io=wt`
	mutation SetCheckinSetTravellersData($params: CheckinSetTravellersData!) {
		CheckinSetTravellersData(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function ao(e){return Gt.useMutation(io,e)}const oo=wt`
	mutation CheckinStart($id: ID!) {
		CheckinStart(id: $id) {
			...CheckinOrder
		}
	}
	${qn}
`;function uo(e){return Gt.useMutation(oo,e)}const so=wt`
	mutation CheckinUpdateTravellers($params: CheckinSetTravellersData!) {
		CheckinSetTravellersData(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function co(e){return Gt.useMutation(so,e)}const lo=wt`
	query CitySuggestions($query: String!) {
		CitySuggestions(query: $query) {
			cities {
				city {
					id
					name
					region
				}
				country {
					id
					name
					codeISO
				}
			}
		}
	}
`;function fo(e){return Gt.useQuery(lo,e)}function mo(e){return Gt.useLazyQuery(lo,e)}const po=wt`
	mutation CompletePayment($orderId: ID!, $transactionId: ID!, $secureCode: String, $additionalText: String) {
		CompletePayment(
			orderId: $orderId
			transactionId: $transactionId
			secureCode: $secureCode
			additionalText: $additionalText
		) {
			result
			order {
				...CheckoutOrder
			}
		}
	}
	${Ai}
`;function ho(e){return Gt.useMutation(po,e)}const go=wt`
	mutation ConfirmChangeTravellerOrder($id: ID!) {
		ConfirmExare(id: $id) {
			...ChangeTravellerDataOrder
		}
	}
	${Ti}
`;function yo(e){return Gt.useMutation(go,e)}const vo=wt`
	mutation CreateChangeTravellerData($parameters: CreateChangeTravellerDataParams!) {
		CreateChangeTravellerData(parameters: $parameters) {
			...ChangeTravellerDataOrder
		}
	}
	${Ti}
`;function So(e){return Gt.useMutation(vo,e)}const Po=wt`
	mutation CreateExchange($params: CreateExchangeParams!) {
		CreateExchange(parameters: $params) {
			...ExchangeOrder
		}
	}
	${Fi}
`;function Do(e){return Gt.useMutation(Po,e)}const Co=wt`
	mutation CreateFfpAccount($params: [NewFfpAccountParameters]) {
		CreateFfpAccount(parameters: $params) {
			result
			message
		}
	}
`;function Fo(e){return Gt.useMutation(Co,e)}const Io=wt`
	mutation CreateOrder($params: CreateOrderParameters!) {
		CreateOrder: CreateActualizedOrder(parameters: $params) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function To(e){return Gt.useMutation(Io,e)}const Oo=wt`
	query GetAvailableDates($departure: String!, $arrival: String!) {
		FlightsSchedule(parameters: { departure: $departure, arrival: $arrival }) {
			datesData {
				date
			}
			flightProbability
		}
	}
`;function Ao(e){return Gt.useQuery(Oo,e)}function $o(e){return Gt.useLazyQuery(Oo,e)}const Eo=wt`
	query FlightsMinPricesInPeriod($params: FlightsMinPricesInPeriodParameters!) {
		FlightsMinPricesInPeriod(parameters: $params) {
			datesWithLowestPrices {
				date
				info
				price {
					amount
					currency
				}
			}
		}
	}
`;function Mo(e){return Gt.useQuery(Eo,e)}function No(e){return Gt.useLazyQuery(Eo,e)}const Ro=wt`
	query FareGroupsCompareTable($iata: String, $flightId: ID, $orderId: ID) {
		FareGroupsCompareTable(iata: $iata, flightId: $flightId, orderId: $orderId) {
			header {
				title
				serviceClass
				image
			}
			groups {
				title
				rows {
					title
					cells {
						availability
						value
						title
						shortDescription
						description
						type
						promo
						isKeyOption
					}
				}
			}
		}
	}
`;function bo(e){return Gt.useQuery(Ro,e)}function xo(e){return Gt.useLazyQuery(Ro,e)}const ko=wt`
	query FareRules($flightId: ID!, $orderId: ID, $language: String!) {
		FareRules(parameters: { flightId: $flightId, orderId: $orderId, language: $language }) {
			rulesForSegments {
				rules {
					code
					fareCode
					name
					text
				}
				segments {
					id
					departure {
						airport {
							id
							name
							iata
							city {
								name
							}
						}
					}
					arrival {
						airport {
							id
							name
							iata
							city {
								name
							}
						}
					}
				}
			}
		}
	}
`;function Lo(e){return Gt.useQuery(ko,e)}function wo(e){return Gt.useLazyQuery(ko,e)}const Go=wt`
	mutation FfpCompleteOrder($id: ID!) {
		FfpCompleteOrder(orderId: $id) {
			result
			order {
				...CheckoutOrder
			}
		}
	}
	${Ai}
`;function Qo(e){return Gt.useMutation(Go,e)}const _o=wt`
	query FfpDefaultAccount {
		FfpDefaultAccount {
			values {
				type
				name
				value
				validationRules {
					...ValidationRule
				}
			}
		}
	}
	${Lr}
`;function Bo(e){return Gt.useQuery(_o,e)}function zo(e){return Gt.useLazyQuery(_o,e)}const Uo=wt`
	query FfpPassbook {
		FfpPassbook
	}
`;function Vo(e){return Gt.useQuery(Uo,e)}function qo(e){return Gt.useLazyQuery(Uo,e)}const Wo=wt`
	mutation FindGroupOrder($params: GroupOrderFindParams) {
		FindGroupOrder(parameters: $params) {
			flight {
				...Flight
			}
			splitOrder {
				...CheckoutOrder
			}
			notMatchedTravellersData {
				id
				lastName
				ticketNumber
			}
		}
	}
	${gi}
	${Ai}
`;function jo(e){return Gt.useMutation(Wo,e)}const Ko=wt`
	mutation FindOrder($params: OrderFind) {
		FindOrder(parameters: $params) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Ho(e){return Gt.useMutation(Ko,e)}const Yo=wt`
	mutation FindOrderAndRequestFfpMiles($parameters: OrderFind) {
		FindOrderAndRequestFfpMiles(parameters: $parameters) {
			result
			message
		}
	}
`;function Jo(e){return Gt.useMutation(Yo,e)}const Xo=wt`
	query FlightStatusLocations {
		LocationSuggestions(parameters: { query: "" }) {
			...LocationGroup
		}
	}
	${nr}
`;function Zo(e){return Gt.useQuery(Xo,e)}function eu(e){return Gt.useLazyQuery(Xo,e)}const tu=wt`
	query GetFlightsFrom($daysAfter: Int!) {
		FlightStatus(parameters: { daysAfter: $daysAfter, daysBefore: 0 }) {
			...FlightStatusResponse
		}
	}
	${ir}
`;function ru(e){return Gt.useQuery(tu,e)}function nu(e){return Gt.useLazyQuery(tu,e)}const iu=wt`
	query FlightsSchedule($parameters: FlightsScheduleParameters!) {
		FlightsSchedule(parameters: $parameters) {
			datesData {
				...FlightsScheduleItem
			}
			flightProbability
		}
	}
	${Yn}
`;function au(e){return Gt.useQuery(iu,e)}function ou(e){return Gt.useLazyQuery(iu,e)}const uu=wt`
	query FullFlightsSchedule($parameters: [FlightsScheduleParameters]!, $period: Period, $groupEqualFlights: Boolean) {
		FullFlightsSchedule(parameters: $parameters, period: $period, groupEqualFlights: $groupEqualFlights) {
			...FullFlightsSchedule
		}
	}
	${yr}
`;function su(e){return Gt.useQuery(uu,e)}function cu(e){return Gt.useLazyQuery(uu,e)}const du=wt`
	query GetCheckinOrder($id: ID!) {
		CheckinOrder(id: $id) {
			...CheckinOrder
		}
	}
	${qn}
`;function lu(e){return Gt.useQuery(du,e)}function fu(e){return Gt.useLazyQuery(du,e)}const mu=wt`
	query GetExchangePrice($params: ExchangePriceParams!) {
		ExchangePrice(params: $params) {
			flightDirections {
				...SearchResultFlightDirections
			}
			flights {
				...PlainFlight
				segments {
					...SegmentWithTransfer
				}
			}
			segments {
				...Segment
			}
			fareGroups {
				...FareGroup
			}
			fareFamilies {
				...FareFamily
			}
			searchParameters {
				...SearchParameters
			}
			messages {
				...InfoMessages
			}
			exchangeVariantPriceInfo {
				...ExareVariantPriceInfo
			}
		}
	}
	${Mr}
	${Tr}
	${Cr}
	${Dr}
	${Er}
	${Ir}
	${li}
	${vr}
	${Rr}
`;function pu(e){return Gt.useQuery(mu,e)}function hu(e){return Gt.useLazyQuery(mu,e)}const gu=wt`
	mutation GetExchangeVariants($params: GetExchangeVariantsParams!) {
		GetExchangeVariants(params: $params) {
			flightDirections {
				legs {
					...ResultsLeg
				}
			}
			fareFamilies {
				...FareFamily
			}
			searchParameters {
				promotionCode
				passengers {
					passengerType
					count
				}
				segments {
					arrival {
						...SearchParametersAirport
					}
					departure {
						...SearchParametersAirport
					}
					date
				}
			}
			exchangeVariantPriceInfo {
				basePrice {
					...Money
				}
				priceToPay {
					...Money
				}
				agencyChargesForExare {
					...Money
				}
				selectedFlightPrice {
					...Money
				}
				selectedFlightPriceWithAirlinePenalty {
					...Money
				}
				selectedFlightTotalPrice {
					...Money
				}
				exchangeAirlinePenalty {
					...Money
				}
				flightId
			}
		}
	}
	${Ar}
	${Ir}
	${di}
	${_t}
`;function yu(e){return Gt.useMutation(gu,e)}const vu=wt`
	query GetGeolocation($parameters: LocationSuggestionsParameters) {
		LocationSuggestions(parameters: $parameters) {
			country {
				name
			}
			type
		}
	}
`;function Su(e){return Gt.useQuery(vu,e)}function Pu(e){return Gt.useLazyQuery(vu,e)}const Du=wt`
	query GetOrdersList {
		CurrentUser {
			ordersList {
				...AccountOrdersList
			}
		}
	}
	${Bt}
`;function Cu(e){return Gt.useQuery(Du,e)}function Fu(e){return Gt.useLazyQuery(Du,e)}const Iu=wt`
	query GetTravellerProfiles($search: String) {
		TravellerProfiles(searchBy: $search) {
			...TravellerProfile
		}
	}
	${mi}
`;function Tu(e){return Gt.useQuery(Iu,e)}function Ou(e){return Gt.useLazyQuery(Iu,e)}const Au=wt`
	query LocationByUserPosition($userPosition: Position!) {
		LocationByUserPosition(userPosition: $userPosition) {
			type
			country {
				id
				name
				codeISO
			}
		}
	}
`;function $u(e){return Gt.useQuery(Au,e)}function Eu(e){return Gt.useLazyQuery(Au,e)}const Mu=wt`
	query Locations($parameters: LocationSuggestionsParameters) {
		LocationSuggestions(parameters: $parameters) {
			...LocationSuggestionGroup
		}
	}
	${kr}
`;function Nu(e){return Gt.useQuery(Mu,e)}function Ru(e){return Gt.useLazyQuery(Mu,e)}const bu=wt`
	mutation Logout {
		Logout {
			result
		}
	}
`;function xu(e){return Gt.useMutation(bu,e)}const ku=wt`
	query MinPrices($params: FlightsMinPricesInPeriodParameters!) {
		FlightsMinPricesInPeriod(parameters: $params) {
			datesWithLowestPrices {
				date
				price {
					amount
					currency
				}
			}
		}
	}
`;function Lu(e){return Gt.useQuery(ku,e)}function wu(e){return Gt.useLazyQuery(ku,e)}const Gu=wt`
	query OrderDocument($params: OrderDocumentParameters!) {
		OrderDocument(parameters: $params)
	}
`;function Qu(e){return Gt.useQuery(Gu,e)}function _u(e){return Gt.useLazyQuery(Gu,e)}const Bu=wt`
	query OrderDocuments($orderId: ID!) {
		OrderDocuments(id: $orderId)
	}
`;function zu(e){return Gt.useQuery(Bu,e)}function Uu(e){return Gt.useLazyQuery(Bu,e)}const Vu=wt`
	query OrderPriceQuery($params: OrderSelectedServices) {
		OrderPrice(parameters: $params) {
			price {
				...OrderPrice
			}
			priceToPay {
				...OrderPrice
			}
		}
	}
	${Pi}
`;function qu(e){return Gt.useQuery(Vu,e)}function Wu(e){return Gt.useLazyQuery(Vu,e)}const ju=wt`
	query OrderPromoCodeInfo($id: ID!, $travellers: [PromoCodeTravellerParameters]!) {
		OrderPromoCodeInfo(id: $id, travellers: $travellers) {
			...OrderPromoCodeInfo
		}
	}
	${ei}
`;function Ku(e){return Gt.useQuery(ju,e)}function Hu(e){return Gt.useLazyQuery(ju,e)}const Yu=wt`
	query OrderSubsidyInfo($id: ID!, $travellers: [SubsidyTravellerParameters]!) {
		OrderSubsidyInfo(id: $id, travellers: $travellers) {
			success
			segments {
				segment {
					...Segment
				}
				travellers {
					traveller {
						...Passenger
					}
					subsidyInfo {
						subsidyId
						rejectMessage
						initialPrice {
							...Money
						}
						discount {
							...Money
						}
						resultPrice {
							...Money
						}
					}
				}
			}
			initialOrderPrice {
				...Money
			}
		}
	}
	${Dr}
	${Zr}
	${_t}
`;function Ju(e){return Gt.useQuery(Yu,e)}function Xu(e){return Gt.useLazyQuery(Yu,e)}const Zu=wt`
	query GetPaxSections($withLastMessage: Boolean) {
		PaximizerCommunicationSections(withLastMessage: $withLastMessage) {
			sections {
				...PaximizerCommunicationSection
			}
		}
	}
	${ri}
`;function es(e){return Gt.useQuery(Zu,e)}function ts(e){return Gt.useLazyQuery(Zu,e)}const rs=wt`
	query GetPaxMyAppealTeasers($offset: Int, $count: Int) {
		PaximizerCommunicationMyAppealTeasers(offset: $offset, count: $count) {
			offset
			total
			count
			items {
				...PaximizerTeaserMyAppealNotification
			}
		}
	}
	${ai}
`;function ns(e){return Gt.useQuery(rs,e)}function is(e){return Gt.useLazyQuery(rs,e)}const as=wt`
	query GetPaxMyPromoCodeTeasers($offset: Int, $count: Int) {
		PaximizerCommunicationMyPromoCodeTeasers(offset: $offset, count: $count) {
			offset
			total
			count
			items {
				...PaximizerTeaserPromoCodeNotification
			}
		}
	}
	${oi}
`;function os(e){return Gt.useQuery(as,e)}function us(e){return Gt.useLazyQuery(as,e)}const ss=wt`
	query GetPaxOrderNotificationTeasers($offset: Int, $count: Int) {
		PaximizerCommunicationOrderNotificationTeasers(offset: $offset, count: $count) {
			offset
			total
			count
			items {
				...PaximazerTeaserOrderInfo
			}
		}
	}
	${ii}
`;function cs(e){return Gt.useQuery(ss,e)}function ds(e){return Gt.useLazyQuery(ss,e)}const ls=wt`
	query GetPaxPromotionTeasers($offset: Int, $count: Int) {
		PaximizerCommunicationPromotionTeasers(offset: $offset, count: $count) {
			offset
			total
			count
			items {
				...PaximizerTeaserPromotionNotification
			}
		}
	}
	${ui}
`;function fs(e){return Gt.useQuery(ls,e)}function ms(e){return Gt.useLazyQuery(ls,e)}const ps=wt`
	query GetPaxOrderNotificationTeasersContent($messageId: ID!, $locatorId: ID) {
		PaximizerCommunicationOrderNotificationContent(messageId: $messageId, locator: $locatorId) {
			...PaximizerCommunicationOrderNotificationContent
		}
	}
	${ci}
`;function hs(e){return Gt.useQuery(ps,e)}function gs(e){return Gt.useLazyQuery(ps,e)}const ys=wt`
	query GetPaxPromotionTeasersContent($messageId: ID!) {
		PaximizerCommunicationPromotionContent(messageId: $messageId) {
			...PaximizerCommunicationNotificationContent
		}
	}
	${si}
`;function vs(e){return Gt.useQuery(ys,e)}function Ss(e){return Gt.useLazyQuery(ys,e)}const Ps=wt`
	query GetPaxMyPromoCodeTeasersContent($messageId: ID!, $locatorId: ID) {
		PaximizerCommunicationMyPromoCodeContent(messageId: $messageId, locator: $locatorId) {
			...PaximizerCommunicationNotificationContent
		}
	}
	${si}
`;function Ds(e){return Gt.useQuery(Ps,e)}function Cs(e){return Gt.useLazyQuery(Ps,e)}const Fs=wt`
	query ReadCommunicationMessage($messageId: ID!, $sectionId: PaximizerCommunicationSectionEnum!) {
		PaximizerCommunicationReadMessage(messageId: $messageId, sectionId: $sectionId)
	}
`;function Is(e){return Gt.useQuery(Fs,e)}function Ts(e){return Gt.useLazyQuery(Fs,e)}const Os=wt`
	query ReadCommunicationSectionMessage($sectionId: PaximizerCommunicationSectionEnum!) {
		PaximizerCommunicationReadSection(sectionId: $sectionId)
	}
`;function As(e){return Gt.useQuery(Os,e)}function $s(e){return Gt.useLazyQuery(Os,e)}const Es=wt`
	query PaymentMethods(
		$parameters: PaymentMethodsParameters!
		$withGpay: Boolean!
		$withCard: Boolean!
		$withCredit: Boolean!
		$withItransfer: Boolean!
		$withKaspi: Boolean!
		$withQiwi: Boolean!
		$withFps: Boolean!
		$withSbol: Boolean!
	) {
		PaymentMethods(parameters: $parameters) {
			gpay {
				...GooglePayMethod
			}
			card {
				...CardPaymentMethod
				transactionId @include(if: $withCard)
				height @include(if: $withCard)
				frameUrl @include(if: $withCard)
			}
			cash {
				...CashMethod
			}
			invoice {
				...InvoiceMethod
			}
			credit {
				...CardPaymentMethod
				transactionId @include(if: $withCredit)
				height @include(if: $withCredit)
				frameUrl @include(if: $withCredit)
			}
			itransfer {
				...CardPaymentMethod
				transactionId @include(if: $withItransfer)
				height @include(if: $withItransfer)
				frameUrl @include(if: $withItransfer)
			}
			sbol {
				...CardPaymentMethod
				transactionId @include(if: $withSbol)
				height @include(if: $withSbol)
				frameUrl @include(if: $withSbol)
			}
			fps {
				...CardPaymentMethod
				transactionId @include(if: $withFps)
				height @include(if: $withFps)
				frameUrl @include(if: $withFps)
			}
			kaspi {
				...GatewayPayment
			}
			qiwi {
				...GatewayPayment
			}
		}
	}
	${Xn}
	${pn}
	${mn}
	${Zn}
	${Jn}
`;function Ms(e){return Gt.useQuery(Es,e)}function Ns(e){return Gt.useLazyQuery(Es,e)}const Rs=wt`
	query GetPersonalDetails {
		Profile {
			documents {
				values {
					name
					value
					validationRules {
						hidden
						hint
						label
						maxDate
						maxLength
						minDate
						options {
							label
							value
						}
						placeholder
						regExp {
							error
							pattern
						}
						required
						with {
							name
							value
						}
					}
				}
			}
			values {
				name
				value
				validationRules {
					hidden
					hint
					label
					maxDate
					maxLength
					minDate
					options {
						label
						value
					}
					placeholder
					regExp {
						error
						pattern
					}
					required
					with {
						name
						value
					}
				}
			}
		}
	}
`;function bs(e){return Gt.useQuery(Rs,e)}function xs(e){return Gt.useLazyQuery(Rs,e)}const ks=wt`
	query GetDefaultPersonalDetails {
		DefaultTravellerProfile {
			documents {
				values {
					name
					value
					validationRules {
						...ValidationRule
					}
				}
			}
			values {
				name
				value
				validationRules {
					...ValidationRule
				}
			}
		}
	}
	${Lr}
`;function Ls(e){return Gt.useQuery(ks,e)}function ws(e){return Gt.useLazyQuery(ks,e)}const Gs=wt`
	mutation SendPersonalDetails($params: UserProfileParameters) {
		UpdateUserProfile(parameters: $params)
	}
`;function Qs(e){return Gt.useMutation(Gs,e)}const _s=wt`
	query PnrHistory($orderId: ID!) {
		PnrHistory(orderId: $orderId) {
			bookId
			pnrCode
			historyElements {
				changeSource
				dateTime
				historyRemarks
			}
		}
	}
`;function Bs(e){return Gt.useQuery(_s,e)}function zs(e){return Gt.useLazyQuery(_s,e)}const Us=wt`
	query ReCaptcha {
		ReCaptcha {
			siteKey
		}
	}
`;function Vs(e){return Gt.useQuery(Us,e)}function qs(e){return Gt.useLazyQuery(Us,e)}const Ws=wt`
	mutation ReCaptchaVerify($token: String!) {
		ReCaptchaVerify(token: $token) {
			result
		}
	}
`;function js(e){return Gt.useMutation(Ws,e)}const Ks=wt`
	query getRefundDocuments($orderId: ID!, $isCompelled: Boolean, $passengers: [Int], $includePrices: Boolean!) {
		GetRefundInfo(orderId: $orderId, isCompelled: $isCompelled, passengers: $passengers) {
			...RefundInfo
		}
	}
	${sn}
`;function Hs(e){return Gt.useQuery(Ks,e)}function Ys(e){return Gt.useLazyQuery(Ks,e)}const Js=wt`
	mutation createRefundOrder($params: CreateRefundParams!) {
		CreateRefund(parameters: $params) {
			...RefundOrder
		}
	}
	${rn}
`;function Xs(e){return Gt.useMutation(Js,e)}const Zs=wt`
	query getLastRefund($orderId: ID) {
		Order(id: $orderId) {
			id
			...OrderWithLastRefund
		}
	}
	${nn}
`;function ec(e){return Gt.useQuery(Zs,e)}function tc(e){return Gt.useLazyQuery(Zs,e)}const rc=wt`
	mutation refuseRefundOrder($id: ID!) {
		RefuseExare(id: $id) {
			id
		}
	}
`;function nc(e){return Gt.useMutation(rc,e)}const ic=wt`
	mutation confirmRefundOrder($id: ID!) {
		ConfirmExare(id: $id) {
			...RefundOrder
		}
	}
	${rn}
`;function ac(e){return Gt.useMutation(ic,e)}const oc=wt`
	mutation nasServicesRefund($params: NASServicesRefundParams!) {
		NASServicesRefund(parameters: $params) {
			serviceId
			travellerId
			status
			error
		}
	}
`;function uc(e){return Gt.useMutation(oc,e)}const sc=wt`
	mutation RefuseExare($id: ID!) {
		RefuseExare(id: $id) {
			...ExareOrder
		}
	}
	${jn}
`;function cc(e){return Gt.useMutation(sc,e)}const dc=wt`
	mutation RefuseExchange($id: ID!) {
		RefuseExare(id: $id) {
			...ExchangeOrder
		}
	}
	${Fi}
`;function lc(e){return Gt.useMutation(dc,e)}const fc=wt`
	mutation RequestFfpMilesForOrder($flightNumber: ID, $flightDate: String, $ticketNumber: String) {
		RequestFfpMilesForOrder(flightNumber: $flightNumber, flightDate: $flightDate, ticketNumber: $ticketNumber) {
			result
			message
		}
	}
`;function mc(e){return Gt.useMutation(fc,e)}const pc=wt`
	mutation ResetOrderPaymentBlock($id: ID!) {
		ResetOrderPaymentBlock(id: $id)
	}
`;function hc(e){return Gt.useMutation(pc,e)}const gc=wt`
	mutation RestoreOrder($id: ID!, $accessToken: String) {
		RestoreOrder(id: $id, accessToken: $accessToken) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function yc(e){return Gt.useMutation(gc,e)}const vc=wt`
	mutation CheckOrderAvailability($id: ID!) {
		CheckOrderAvailability(id: $id) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Sc(e){return Gt.useMutation(vc,e)}const Pc=wt`
	query SearchResults($id: ID!) {
		SearchResult(id: $id) {
			searchParameters {
				...SearchParameters
			}
			fareFamilies {
				...FareFamily
			}
			flightDirections {
				...FlightDirection
			}
			messages {
				...InfoMessages
			}
			fares {
				...ResultFare
			}
		}
	}
	${li}
	${Ir}
	${cn}
	${vr}
	${ln}
`;function Dc(e){return Gt.useQuery(Pc,e)}function Cc(e){return Gt.useLazyQuery(Pc,e)}const Fc=wt`
	mutation RunSearch($params: AviaSearchParameters!) {
		RunGeneralSearch(parameters: $params) {
			id
		}
	}
`;function Ic(e){return Gt.useMutation(Fc,e)}const Tc=wt`
	mutation SaveClientInfo($orderId: String!, $email: String!, $phone: String!) {
		successfullySaved: SaveClientInfo(orderId: $orderId, email: $email, phone: $phone)
	}
`;function Oc(e){return Gt.useMutation(Tc,e)}const Ac=wt`
	query SeatMap($id: ID) {
		SeatMap(orderId: $id) {
			...FlightSeatMap
		}
	}
	${zn}
`;function $c(e){return Gt.useQuery(Ac,e)}function Ec(e){return Gt.useLazyQuery(Ac,e)}const Mc=wt`
	mutation SelectCheckinSegments($params: CheckinSelectSegments!) {
		CheckinSelectSegments(parameters: $params) {
			...CheckinOrder
		}
	}
	${qn}
`;function Nc(e){return Gt.useMutation(Mc,e)}const Rc=wt`
	mutation FFPNewFFPPassword($cardNumber: String!, $airlineCode: String!, $code: String!) {
		SendNewFfpPassword(cardNumber: $cardNumber, airlineCode: $airlineCode, code: $code)
	}
`;function bc(e){return Gt.useMutation(Rc,e)}const xc=wt`
	mutation FFPResetPasswordCode($email: String!, $airlineCode: String!) {
		SendResetFfpPasswordCode(email: $email, airlineCode: $airlineCode)
	}
`;function kc(e){return Gt.useMutation(xc,e)}const Lc=wt`
	query GetServicesRefundInfo($params: ExareGdsServicesRefundBaseParams!) {
		GetGdsServicesRefundInfo(parameters: $params) {
			gdsServicesRefundInfo {
				service {
					...GdsService
				}
				gdsServiceProductsRefundInfo {
					product {
						...PassengerSelectedGdsServicesProduct
					}
					sumToRefund {
						...Money
					}
					refundable
					isVoid
				}
			}
		}
	}
	${jr}
	${Qr}
	${_t}
`;function wc(e){return Gt.useQuery(Lc,e)}function Gc(e){return Gt.useLazyQuery(Lc,e)}const Qc=wt`
	mutation SetOrderStatus($orderId: ID!, $status: OrderStatus) {
		SetOrderStatus(parameters: { orderId: $orderId, newStatus: $status }) {
			id
		}
	}
`;function _c(e){return Gt.useMutation(Qc,e)}const Bc=wt`
	mutation SetSsrData($parameters: SetSsrParams!) {
		SetSsrData(parameters: $parameters) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function zc(e){return Gt.useMutation(Bc,e)}const Uc=wt`
	mutation AddTravellersData($variables: SetTravellersData!) {
		SetTravellersData(parameters: $variables) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Vc(e){return Gt.useMutation(Uc,e)}const qc=wt`
	mutation CreateNewCompanion($params: NewTravellerParameters) {
		CreateTravellerProfile(parameters: $params)
	}
`;function Wc(e){return Gt.useMutation(qc,e)}const jc=wt`
	query GetCompanions($search: String) {
		TravellerProfiles(searchBy: $search) {
			documents {
				values {
					...TravellerParameter
				}
			}
			id
			values {
				...TravellerParameter
			}
		}
	}
	${wr}
`;function Kc(e){return Gt.useQuery(jc,e)}function Hc(e){return Gt.useLazyQuery(jc,e)}const Yc=wt`
	query DefaultTravellerFields {
		DefaultTravellerProfile {
			...TravellerProfile
		}
	}
	${mi}
`;function Jc(e){return Gt.useQuery(Yc,e)}function Xc(e){return Gt.useLazyQuery(Yc,e)}const Zc=wt`
	query DocumentsValidations {
		DefaultTravellerProfile {
			documents {
				values {
					...TravellerParameterEditable
				}
			}
		}
	}
	${Gr}
`;function ed(e){return Gt.useQuery(Zc,e)}function td(e){return Gt.useLazyQuery(Zc,e)}const rd=wt`
	mutation DeleteTraveller($id: ID) {
		DeleteTravellerProfile(id: $id)
	}
`;function nd(e){return Gt.useMutation(rd,e)}const id=wt`
	mutation UpdateTraveller($params: UpdateTravellerParameters) {
		UpdateTravellerProfile(parameters: $params)
	}
`;function ad(e){return Gt.useMutation(id,e)}const od=wt`
	mutation UpdateCheckinOrder($id: ID) {
		UpdateCheckinOrder(id: $id) {
			...CheckinOrder
		}
	}
	${qn}
`;function ud(e){return Gt.useMutation(od,e)}const sd=wt`
	mutation UpdateOrder($id: ID) {
		UpdateOrder(id: $id) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function cd(e){return Gt.useMutation(sd,e)}const dd=wt`
	query GetAviaOrdersList {
		AviaOrdersList(parameters: { filterParameters: {} }) {
			...AccountOrdersList
		}
	}
	${Bt}
`;function ld(e){return Gt.useQuery(dd,e)}function fd(e){return Gt.useLazyQuery(dd,e)}const md=wt`
	query Order($id: ID!) {
		Order(id: $id) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function pd(e){return Gt.useQuery(md,e)}function hd(e){return Gt.useLazyQuery(md,e)}const gd=wt`
	mutation ActualizeOrder($id: ID) {
		ActualizeOrder(id: $id) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function yd(e){return Gt.useMutation(gd,e)}const vd=wt`
	mutation SendSecureCode($params: SendSecureCodeParameters!) {
		SendSecureCode(parameters: $params) {
			result
			message
		}
	}
`;function Sd(e){return Gt.useMutation(vd,e)}const Pd=wt`
	mutation Authenticate($params: AuthCredentials!) {
		Authenticate(parameters: $params) {
			type
			token
			expiresIn
		}
	}
`;function Dd(e){return Gt.useMutation(Pd,e)}const Cd=wt`
	query SocialAuth($params: OauthRedirectUrlParameters!) {
		OauthRedirectUrl(parameters: $params) {
			result
			message
		}
	}
`;function Fd(e){return Gt.useQuery(Cd,e)}function Id(e){return Gt.useLazyQuery(Cd,e)}const Td=wt`
	mutation SaveOrderServices($params: OrderSelectedServices) {
		SaveOrderServices(parameters: $params) {
			...CheckoutOrder
		}
	}
	${Ai}
`;function Od(e){return Gt.useMutation(Td,e)}const Ad=wt`
	query OrderPriceBreakdown($params: OrderSelectedServices) {
		OrderPriceBreakdown(parameters: $params) {
			...PriceBreakdownDetails
		}
	}
	${Un}
`;function $d(e){return Gt.useQuery(Ad,e)}function Ed(e){return Gt.useLazyQuery(Ad,e)}const Md=wt`
	mutation HandleMetasearchRedirect($id: ID) {
		HandleMetasearchRedirect(id: $id) {
			searchId
			order {
				...CheckoutOrder
			}
		}
	}
	${Ai}
`;function Nd(e){return Gt.useMutation(Md,e)}const Rd=wt`
	mutation ResendItineraryReceipt($params: ResendItineraryReceiptParameters) {
		ResendItineraryReceipt(parameters: $params)
	}
`;function bd(e){return Gt.useMutation(Rd,e)}const xd=wt`
	query OrderServicesWithPurchasePrediction($id: ID!) {
		Order(id: $id) {
			...OrderAdditionalServicesWithPrediction
		}
	}
	${Ri}
`;function kd(e){return Gt.useQuery(xd,e)}function Ld(e){return Gt.useLazyQuery(xd,e)}}])}));